/**
 * i18n fail-safe (2026-08-21) : lit la table de naked-size-widget-translations.js
 * si elle est chargée, sinon retombe TOUJOURS sur le texte français d'origine.
 * Le français reste le défaut : aucune régression possible sur les locales fr.
 */
window.nakedSizeT = window.nakedSizeT || function (key, fallback) {
  try {
    var t = window.NAKED_SIZE_TRANSLATIONS;
    if (t && typeof t.getTranslation === 'function') {
      var v = t.getTranslation(key);
      if (typeof v === 'string' && v !== key) return v;
    }
  } catch (e) { /* ignore */ }
  return fallback;
};

(function() {
  'use strict';

  // Configuration globale
  const config = {
    // Systèmes de tailles
    sizingSystems: {
      'EU': {
        bands: [60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125, 130],
        cups: ['AA', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N']
      },
      'UK': {
        bands: [28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56],
        cups: ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J', 'JJ']
      },
      'US': {
        bands: [28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56],
        cups: ['AA', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N']
      },
      'AUS': {
        bands: [6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34],
        cups: ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J', 'JJ']
      }
    },
    
    // Table de conversion des tailles de bas
    bottomSizes: {
      'EU': [34, 36, 38, 40, 42, 44, 46, 48, 50, 52],
      'UK': [6, 8, 10, 12, 14, 16, 18, 20, 22, 24],
      'US': [2, 4, 6, 8, 10, 12, 14, 16, 18, 20],
      'AUS': [6, 8, 10, 12, 14, 16, 18, 20, 22, 24]
    },
    
    // Correspondance entre tailles traditionnelles et tailles S/M/L
    sizeMapping: {
      top: {
        'S': { minBand: 60, maxBand: 85, minCup: 0, maxCup: 3 },
        'M': { minBand: 85, maxBand: 95, minCup: 1, maxCup: 4 },
        'L': { minBand: 90, maxBand: 95, minCup: 2, maxCup: 5 },
        'XL': { minBand: 95, maxBand: 105, minCup: 3, maxCup: 6 }
      },
      bottom: {
        'S': [34, 36, 38],
        'M': [38, 40, 42],
        'L': [42, 44, 46],
        'XL': [46, 48, 50, 52]
      }
    },
    
    // Textes pour les messages de preuve sociale
    socialProofMessages: {
      body: window.nakedSizeT('social_proof_body', "Nos clientes ayant votre morphologie choisissent cette taille"),
      ensemble: window.nakedSizeT('social_proof_ensemble', "Nos clientes ayant votre morphologie choisissent ces tailles pour leur ensemble")
    },
    
    // Configuration des sliders pour chaque type de mesure (utilisé uniquement sur mobile)
    sliders: {
      'height': {
        metric: {
          min: 140,
          max: 210,
          step: 1,
          unit: 'cm',
          default: 165,
          convertTo: (val) => (val / 30.48).toFixed(2)  // cm vers pieds
        },
        imperial: {
          min: 4.6,
          max: 6.9,
          step: 0.01,
          unit: 'ft',
          default: 5.41,
          display: (val) => {
            // Convertir en pieds et pouces pour l'affichage
            const feet = Math.floor(val);
            const inches = Math.round((val - feet) * 12);
            return `${feet} ft ${inches} in`;
          },
          convertTo: (val) => Math.round(val * 30.48)  // pieds vers cm
        }
      },
      'weight': {
        metric: {
          min: 40,
          max: 100,
          step: 1,
          unit: 'kg',
          default: 60,
          convertTo: (val) => Math.round(val * 2.20462)  // kg vers livres
        },
        imperial: {
          min: 88,
          max: 220,
          step: 1,
          unit: 'lbs',
          default: 132,
          convertTo: (val) => Math.round(val / 2.20462)  // livres vers kg
        }
      },
      'age': {
        metric: {
          min: 18,
          max: 70,
          step: 1,
          unit: 'ans',
          default: 35,
          convertTo: (val) => val  // Pas de conversion pour l'âge
        }
      }
    }
  };
  
  // Identifiant pour le stockage local
  const STORAGE_KEY = 'naked_size_data';
  
  /**
   * Classe pour le widget de recommandation de tailles
   */
  class NAKEDSizeRecommender {
    constructor() {
      // Éléments DOM
      this.sizeButton = document.getElementById('naked-size-button');
      this.sizePopup = document.getElementById('naked-size-popup');
      this.progressDots = document.querySelectorAll('.naked-size-progress-dot');
      
      // Données utilisateur
      this.userData = {
        height: null,
        weight: null,
        age: null,
        stomach: null,
        hips: null,
        seat: null,
        braSize: { band: null, cup: null, system: 'EU' },
        bottomSize: { size: null, system: 'EU' }
      };
      
      this.currentUnit = 'metric';
      this.currentStep = 1;
      this.productType = this.detectProductType();
      this.isMobile = window.innerWidth <= 768;
      
      // Facteurs d'influence pour l'algorithme de recommandation (somme = 100%)
      this.factors = {
        top: {
          braSizeMatrix: 0.80,  // 80% basé sur la matrice de correspondance
          bmi: 0.10,            // 10% basé sur l'IMC
          morphology: 0.05,     // 5% basé sur la morphologie
          age: 0.05             // 5% basé sur l'âge
        },
        bottom: {
          euSizeMatrix: 0.75,   // 75% basé sur la taille EU
          bmi: 0.15,            // 15% basé sur l'IMC
          morphology: 0.05,     // 5% basé sur la morphologie
          proportions: 0.05     // 5% basé sur les proportions (rapport taille/hanches)
        }
      };
      
      // Initialisation
      this.init();
    }
    
    // Initialisation du widget
    init() {
      this.setProductImage();
      this.initializeSizeButtons();
      
      // Si on est sur mobile, créer le bouton de fermeture pour la popup modale
      if (this.isMobile) {
        // Vérifier si le bouton existe déjà
        if (!document.querySelector('.naked-size-close-btn')) {
          // Créer le bouton de fermeture X
          const closeButton = document.createElement('button');
          closeButton.className = 'naked-size-close-btn';
          closeButton.setAttribute('aria-label', window.nakedSizeT('close', 'Fermer'));
          
          // Insérer le bouton dans le contenu de la popup
          const popupContent = this.sizePopup.querySelector('.naked-size-popup-content');
          if (popupContent) {
            popupContent.appendChild(closeButton);
          }
        }
        
        // Initialiser les sliders pour mobile
        this.initializeMobileSliders();
      }
      
      this.setupEventListeners();
      
      // Ajouter le titre du produit comme attribut data pour le CSS
      const formSide = document.querySelector('.naked-size-form-side');
      if (formSide) {
        const productTitle = document.querySelector('.naked-size-popup-title h2');
        if (productTitle) {
          formSide.setAttribute('data-product-title', productTitle.textContent);
        }
      }
      
      // Définir les valeurs par défaut dans les champs de formulaire
      this.setDefaultFieldValues();
      
      console.log('NAKED Size Widget initialized');
    }
    
    // Définir les valeurs par défaut et activer le bouton Suivant
    setDefaultFieldValues() {
      // Définir les valeurs par défaut pour les champs
      const heightInput = document.getElementById('naked-size-height');
      const weightInput = document.getElementById('naked-size-weight');
      const ageInput = document.getElementById('naked-size-age');
      
      if (heightInput && !heightInput.value) {
        heightInput.value = config.sliders.height.metric.default;
      }
      
      if (weightInput && !weightInput.value) {
        weightInput.value = config.sliders.weight.metric.default;
      }
      
      if (ageInput && !ageInput.value) {
        ageInput.value = config.sliders.age.metric.default;
      }
      
      // Activer immédiatement le bouton si les valeurs sont définies
      this.checkStep1Completion();
    }
    
    /**
     * Initialisation des sliders pour la version mobile
     */
    initializeMobileSliders() {
      // Nettoyer les sliders existants avant d'en créer de nouveaux
      document.querySelectorAll('.naked-size-slider-container').forEach(container => {
        container.remove();
      });
      
      // Puis réinitialiser les conteneurs d'input originaux
      document.querySelectorAll('.naked-size-input-container').forEach(container => {
        container.classList.remove('naked-size-mobile-hidden');
      });
      
      // Convertir chaque champ en slider
      this.setupSlider('height', config.sliders.height.metric.default);
      this.setupSlider('weight', config.sliders.weight.metric.default);
      this.setupSlider('age', config.sliders.age.metric.default);
      
      console.log('Mobile sliders initialized');
    }
    
    /**
     * Création d'un slider pour remplacer un champ input sur mobile
     * @param {string} field - Nom du champ (height, weight, age)
     * @param {number} defaultValue - Valeur par défaut
     */
    setupSlider(field, defaultValue) {
      const inputField = document.getElementById(`naked-size-${field}`);
      if (!inputField) return;
      
      const fieldContainer = inputField.closest('.naked-size-form-field');
      if (!fieldContainer) return;
      
      // Vérifier si un slider existe déjà pour éviter les doublons
      if (fieldContainer.querySelector('.naked-size-slider-container')) {
        console.log(`Un slider existe déjà pour le champ ${field}, évite la duplication`);
        return;
      }
      
      // Cacher le conteneur d'input original
      const inputContainer = fieldContainer.querySelector('.naked-size-input-container');
      if (inputContainer) {
        inputContainer.classList.add('naked-size-mobile-hidden');
      }
      
      // Créer un container élégant
      const sliderContainer = document.createElement('div');
      sliderContainer.className = 'naked-size-slider-container';
      
      // Créer une ligne valeur+unités élégante
      const valueUnitRow = document.createElement('div');
      valueUnitRow.className = 'naked-size-value-unit-row';
      
      // Conteneur pour la valeur
      const valueContainer = document.createElement('div');
      valueContainer.className = 'naked-size-value-container';
      
      // Affichage de la valeur
      const valueDisplay = document.createElement('div');
      valueDisplay.className = 'naked-size-slider-value';
      valueDisplay.id = `naked-size-${field}-value`;
      valueContainer.appendChild(valueDisplay);
      
      // Vérifier si le champ a un sélecteur d'unités
      const unitsContainer = fieldContainer.querySelector('.naked-size-units');
      let mobileUnits = null;
      
      if (unitsContainer && field !== 'age') {
        const unitButtons = unitsContainer.querySelectorAll('.naked-size-unit');
        
        // Créer un sélecteur d'unités élégant
        mobileUnits = document.createElement('div');
        mobileUnits.className = 'naked-size-units-mobile';
        
        // Ajouter les boutons d'unités
        unitButtons.forEach(button => {
          const unit = button.getAttribute('data-unit');
          const isActive = button.classList.contains('active');
          
          const newButton = document.createElement('span');
          newButton.className = `naked-size-unit-mobile${isActive ? ' active' : ''}`;
          newButton.setAttribute('data-unit', unit);
          newButton.textContent = unit;
          
          // Écouteur d'événement pour le changement d'unité
          newButton.addEventListener('click', () => {
            mobileUnits.querySelectorAll('.naked-size-unit-mobile').forEach(btn => {
              btn.classList.remove('active');
            });
            newButton.classList.add('active');
            
            const isMetric = unit === 'cm' || unit === 'kg';
            this.updateSliderUnit(field, isMetric ? 'metric' : 'imperial');
            
            const originalUnitButtons = unitsContainer.querySelectorAll('.naked-size-unit');
            originalUnitButtons.forEach(btn => {
              btn.classList.remove('active');
              if (btn.getAttribute('data-unit') === unit) {
                btn.classList.add('active');
              }
            });
            
            this.currentUnit = isMetric ? 'metric' : 'imperial';
          });
          
          mobileUnits.appendChild(newButton);
        });
      }
      
      // Assembler la ligne de valeur
      valueUnitRow.appendChild(valueContainer);
      if (mobileUnits) {
        valueUnitRow.appendChild(mobileUnits);
      }
      
      // Créer un slider élégant
      const trackContainer = document.createElement('div');
      trackContainer.className = 'naked-size-slider-track-container';
      
      const track = document.createElement('div');
      track.className = 'naked-size-slider-track';
      
      const progress = document.createElement('div');
      progress.className = 'naked-size-slider-progress';
      progress.id = `naked-size-${field}-progress`;
      
      const handle = document.createElement('div');
      handle.className = 'naked-size-slider-handle';
      handle.id = `naked-size-${field}-handle`;
      
      const rangeInput = document.createElement('input');
      rangeInput.type = 'range';
      rangeInput.className = 'naked-size-slider-input';
      rangeInput.id = `naked-size-${field}-slider`;
      
      // Configurer le slider
      const sliderConfig = config.sliders[field][this.currentUnit];
      rangeInput.min = sliderConfig.min;
      rangeInput.max = sliderConfig.max;
      rangeInput.step = sliderConfig.step;
      rangeInput.value = defaultValue;
      
      // Indicateurs min/max élégants
      const minIndicator = document.createElement('span');
      minIndicator.className = 'naked-size-slider-min';
      minIndicator.textContent = sliderConfig.min;
      
      const maxIndicator = document.createElement('span');
      maxIndicator.className = 'naked-size-slider-max';
      maxIndicator.textContent = sliderConfig.max;
      
      // Assembler la structure du slider
      track.appendChild(progress);
      trackContainer.appendChild(track);
      trackContainer.appendChild(handle);
      trackContainer.appendChild(rangeInput);
      trackContainer.appendChild(minIndicator);
      trackContainer.appendChild(maxIndicator);
      
      // Assembler le container final
      sliderContainer.appendChild(valueUnitRow);
      sliderContainer.appendChild(trackContainer);
      
      // Ajouter le slider au conteneur du champ
      fieldContainer.appendChild(sliderContainer);
      
      // Définir la valeur initiale du champ input
      inputField.value = defaultValue;
      
      // Initialiser l'affichage
      this.updateSliderValue(field, defaultValue);
      
      // Position initiale
      const percent = (defaultValue - sliderConfig.min) / (sliderConfig.max - sliderConfig.min) * 100;
      handle.style.left = `${percent}%`;
      progress.style.width = `${percent}%`;
      
      // AMÉLIORATION DE LA FLUIDITÉ
      // Fonction pour mettre à jour visuellement le slider de manière fluide
      const updateSliderVisually = (value) => {
        // Calcul du pourcentage pour positionner le curseur et la barre de progression
        const currentConfig = config.sliders[field][this.currentUnit];
        const percent = (value - currentConfig.min) / (currentConfig.max - currentConfig.min) * 100;
        
        // Utiliser requestAnimationFrame pour des animations plus fluides
        requestAnimationFrame(() => {
          // Mettre à jour simultanément le curseur et la barre de progression
          handle.style.left = `${percent}%`;
          progress.style.width = `${percent}%`;
        });
      };
      
      // Fonction pour mettre à jour la valeur affichée et déclencher les validations
      const updateValue = (value) => {
        // Mettre à jour l'affichage de la valeur
        this.updateSliderValue(field, value);
        
        // Mettre à jour le champ d'origine
        inputField.value = value;
        
        // Déclencher l'événement pour la validation
        const event = new Event('input', { bubbles: true });
        inputField.dispatchEvent(event);
      };
      
      // Variables pour le suivi du toucher
      let isTracking = false;
      let startX, startLeft, trackWidth;
      
      // Gestionnaire d'événement d'entrée standard (pour les interactions non tactiles)
      rangeInput.addEventListener('input', (e) => {
        const value = parseFloat(e.target.value);
        updateSliderVisually(value);
        updateValue(value);
      });
      
      // AMÉLIORATIONS DE LA FLUIDITÉ DES CURSEURS MOBILES
      
      // Gestion des événements tactiles pour une animation plus fluide
      handle.addEventListener('touchstart', (e) => {
        isTracking = true;
        e.preventDefault(); // Empêcher le défilement de la page
        
        // Récupérer la position initiale du toucher et du curseur
        startX = e.touches[0].clientX;
        startLeft = parseFloat(window.getComputedStyle(handle).left);
        trackWidth = track.getBoundingClientRect().width;
        
        // Désactiver les transitions CSS pour un suivi plus fluide
        handle.style.transition = 'none';
        progress.style.transition = 'none';
        
        // Ajouter la classe active au curseur
        handle.classList.add('active');
      });
      
      // Amélioration de la sensibilité du toucher - utiliser tout le track
      track.addEventListener('touchstart', (e) => {
        // Calculer la position de clic dans le track
        const trackRect = track.getBoundingClientRect();
        const clickX = e.touches[0].clientX - trackRect.left;
        const percent = (clickX / trackRect.width) * 100;
        
        // Calculer la valeur
        const currentConfig = config.sliders[field][this.currentUnit];
        const range = currentConfig.max - currentConfig.min;
        const value = currentConfig.min + (range * percent / 100);
        const roundedValue = Math.round(value / currentConfig.step) * currentConfig.step;
        
        // Positionner le curseur
        updateSliderVisually(roundedValue);
        updateValue(roundedValue);
        rangeInput.value = roundedValue;
        
        // Commencer le suivi
        isTracking = true;
        startX = e.touches[0].clientX;
        startLeft = clickX;
        trackWidth = trackRect.width;
        
        // Désactiver les transitions
        handle.style.transition = 'none';
        progress.style.transition = 'none';
        handle.classList.add('active');
        
        e.preventDefault(); // Empêcher le défilement
      });
      
      document.addEventListener('touchmove', (e) => {
        if (!isTracking) return;
        
        const currentX = e.touches[0].clientX;
        const deltaX = currentX - startX;
        
        // Calculer la nouvelle position en pourcentage (limité entre 0 et 100%)
        let newPercent = (startLeft + deltaX) / trackWidth * 100;
        newPercent = Math.max(0, Math.min(100, newPercent));
        
        // Calculer la valeur correspondante
        const currentConfig = config.sliders[field][this.currentUnit];
        const range = currentConfig.max - currentConfig.min;
        const value = currentConfig.min + (range * newPercent / 100);
        const roundedValue = Math.round(value / currentConfig.step) * currentConfig.step;
        
        // Mettre à jour l'affichage visuel
        updateSliderVisually(roundedValue);
        updateValue(roundedValue);
        
        // Mettre à jour également la valeur de l'input range
        rangeInput.value = roundedValue;
      });
      
      document.addEventListener('touchend', () => {
        if (!isTracking) return;
        
        // Réactiver les transitions CSS
        handle.style.transition = '';
        progress.style.transition = '';
        
        // Supprimer la classe active
        handle.classList.remove('active');
        
        isTracking = false;
      });
      
      // Ajouter un gestionnaire de clic pour le track (version non tactile)
      track.addEventListener('click', (e) => {
        // Seulement si nous ne sommes pas en train de faire glisser
        if (!isTracking) {
          const trackRect = track.getBoundingClientRect();
          const clickX = e.clientX - trackRect.left;
          const percent = (clickX / trackRect.width) * 100;
          
          // Calculer la valeur
          const currentConfig = config.sliders[field][this.currentUnit];
          const range = currentConfig.max - currentConfig.min;
          const value = currentConfig.min + (range * percent / 100);
          const roundedValue = Math.round(value / currentConfig.step) * currentConfig.step;
          
          // Mettre à jour
          updateSliderVisually(roundedValue);
          updateValue(roundedValue);
          rangeInput.value = roundedValue;
        }
      });
    }
    
    /**
     * Mise à jour de l'affichage de la valeur du slider
     * @param {string} field - Nom du champ
     * @param {number} value - Valeur actuelle
     */
    updateSliderValue(field, value) {
      const valueDisplay = document.getElementById(`naked-size-${field}-value`);
      if (!valueDisplay) return;
      
      const unitType = this.currentUnit;
      const sliderConfig = config.sliders[field][unitType] || config.sliders[field].metric;
      
      // Réinitialiser le contenu
      valueDisplay.innerHTML = '';
      
      // Ajouter la valeur principale avec un formatage élégant
      const valueText = document.createTextNode(
        sliderConfig.display ? sliderConfig.display(value).split(' ')[0] : value
      );
      valueDisplay.appendChild(valueText);
      
      // Unité principale plus élégante
      const unitSpan = document.createElement('span');
      unitSpan.className = 'naked-size-primary-unit';
      
      if (sliderConfig.display) {
        // Pour les affichages personnalisés (comme ft in)
        const displayParts = sliderConfig.display(value).split(' ');
        unitSpan.textContent = displayParts.slice(1).join(' ');
      } else {
        unitSpan.textContent = sliderConfig.unit;
      }
      valueDisplay.appendChild(unitSpan);
      
      // Conversion d'unité plus élégante
      if (unitType === 'metric' && field !== 'age' && sliderConfig.convertTo) {
        const alternateValue = sliderConfig.convertTo(value);
        const conversionSpan = document.createElement('span');
        conversionSpan.className = 'naked-size-unit-conversion';
        
        // Format élégant et lisible
        if (field === 'height') {
          const feet = Math.floor(alternateValue);
          const inches = Math.round((alternateValue - feet) * 12);
          conversionSpan.textContent = `(${feet}ft ${inches}in)`;
        } else {
          conversionSpan.textContent = `(${alternateValue} lbs)`;
        }
        valueDisplay.appendChild(conversionSpan);
      } else if (unitType === 'imperial' && field !== 'age' && sliderConfig.convertTo) {
        const alternateValue = sliderConfig.convertTo(value);
        const conversionSpan = document.createElement('span');
        conversionSpan.className = 'naked-size-unit-conversion';
        conversionSpan.textContent = `(${alternateValue} ${field === 'height' ? 'cm' : 'kg'})`;
        valueDisplay.appendChild(conversionSpan);
      }
    }
    
    /**
     * Mise à jour du slider lors du changement d'unité
     * @param {string} field - Nom du champ
     * @param {string} unitType - Type d'unité ('metric' ou 'imperial')
     */
    updateSliderUnit(field, unitType) {
      const slider = document.getElementById(`naked-size-${field}-slider`);
      const handle = document.getElementById(`naked-size-${field}-handle`);
      const progress = document.getElementById(`naked-size-${field}-progress`);
      const inputField = document.getElementById(`naked-size-${field}`);
      
      if (!slider || !handle || !progress || !inputField) return;
      
      // Récupérer la valeur actuelle
      const currentValue = parseFloat(slider.value);
      
      // Récupérer la configuration pour la nouvelle unité
      const sliderConfig = config.sliders[field][unitType];
      
      // Convertir la valeur selon l'unité
      let newValue;
      if (unitType === 'metric' && field !== 'age') {
        newValue = config.sliders[field].imperial.convertTo(currentValue);
      } else if (unitType === 'imperial' && field !== 'age') {
        newValue = config.sliders[field].metric.convertTo(currentValue);
      } else {
        newValue = currentValue;  // Pas de conversion pour l'âge
      }
      
      // Mettre à jour les propriétés du slider
      slider.min = sliderConfig.min;
      slider.max = sliderConfig.max;
      slider.step = sliderConfig.step;
      slider.value = newValue;
      
      // Mettre à jour la position du curseur et la progression
      const percent = (newValue - sliderConfig.min) / (sliderConfig.max - sliderConfig.min) * 100;
      handle.style.left = `${percent}%`;
      progress.style.width = `${percent}%`;
      
      // Mettre à jour l'affichage de la valeur
      this.updateSliderValue(field, newValue);
      
      // Mettre à jour les indicateurs min/max
      const minIndicator = handle.parentNode.querySelector('.naked-size-slider-min');
      const maxIndicator = handle.parentNode.querySelector('.naked-size-slider-max');
      
      if (minIndicator) minIndicator.textContent = sliderConfig.min;
      if (maxIndicator) maxIndicator.textContent = sliderConfig.max;
      
      // Mettre à jour le champ d'origine
      inputField.value = newValue;
      
      // Déclencher l'événement input pour la validation
      const event = new Event('input', { bubbles: true });
      inputField.dispatchEvent(event);
    }
    
    // Vérifie si l'étape 1 est complète
    checkStep1Completion() {
      const heightInput = document.getElementById('naked-size-height');
      const weightInput = document.getElementById('naked-size-weight');
      const ageInput = document.getElementById('naked-size-age');
      const nextButton = document.getElementById('step1-next');
      
      if (heightInput && weightInput && ageInput && nextButton) {
        if (heightInput.value && weightInput.value && ageInput.value) {
          nextButton.classList.add('active');
          nextButton.removeAttribute('disabled');
        } else {
          nextButton.classList.remove('active');
          nextButton.setAttribute('disabled', 'disabled');
        }
      }
    }
    
    // Vérifie si l'étape 2 est complète (Ventre)
    checkStep2Completion() {
      const selectedOption = document.querySelector('.naked-size-step[data-step="2"] .naked-size-morphology-option.selected');
      const nextButton = document.getElementById('step2-next');
      
      if (nextButton) {
        if (selectedOption) {
          nextButton.classList.add('active');
          nextButton.removeAttribute('disabled');
        } else {
          nextButton.classList.remove('active');
          nextButton.setAttribute('disabled', 'disabled');
        }
      }
    }
    
    // Vérifie si l'étape 3 est complète (Hanches)
    checkStep3Completion() {
      const selectedOption = document.querySelector('.naked-size-step[data-step="3"] .naked-size-morphology-option.selected');
      const nextButton = document.getElementById('step3-next');
      
      if (nextButton) {
        if (selectedOption) {
          nextButton.classList.add('active');
          nextButton.removeAttribute('disabled');
        } else {
          nextButton.classList.remove('active');
          nextButton.setAttribute('disabled', 'disabled');
        }
      }
    }
    
    // Vérifie si l'étape 4 est complète (Fesses)
    checkStep4Completion() {
      const selectedOption = document.querySelector('.naked-size-step[data-step="4"] .naked-size-morphology-option.selected');
      const nextButton = document.getElementById('step4-next');
      
      if (nextButton) {
        if (selectedOption) {
          nextButton.classList.add('active');
          nextButton.removeAttribute('disabled');
        } else {
          nextButton.classList.remove('active');
          nextButton.setAttribute('disabled', 'disabled');
        }
      }
    }
    
    // Vérifie si l'étape 5 est complète (Taille soutien-gorge)
    checkStep5Completion() {
      const selectedBand = document.querySelector('#band-size-buttons .naked-size-size-btn.selected');
      const selectedCup = document.querySelector('#cup-size-buttons .naked-size-size-btn.selected');
      const nextButton = document.getElementById('step5-next');
      
      if (nextButton) {
        if (selectedBand && selectedCup) {
          nextButton.classList.add('active');
          nextButton.removeAttribute('disabled');
        } else {
          nextButton.classList.remove('active');
          nextButton.setAttribute('disabled', 'disabled');
        }
      }
    }
    
    // Vérifie si l'étape 6 est complète (Taille de bas)
    checkStep6Completion() {
      const selectedSize = document.querySelector('#bottom-size-buttons .naked-size-size-btn.selected');
      const nextButton = document.getElementById('step6-next');
      
      if (nextButton) {
        if (selectedSize) {
          nextButton.classList.add('active');
          nextButton.removeAttribute('disabled');
        } else {
          nextButton.classList.remove('active');
          nextButton.setAttribute('disabled', 'disabled');
        }
      }
    }
    
    // Détection du type de produit
    detectProductType() {
      // Récupérer le titre du produit de différentes façons possibles selon la structure du site
      const productTitle = document.querySelector('.product__title h1')?.textContent || 
                         document.querySelector('.product-single__title')?.textContent || 
                         document.querySelector('h1.product-title')?.textContent ||
                         document.querySelector('h1')?.textContent || 
                         document.querySelector('.product-title')?.textContent ||
                         document.querySelector('.naked-size-popup-title h2')?.textContent ||
                         '';
      
      console.log("Titre du produit détecté:", productTitle);
      
      // Vérifier d'abord si c'est un body (priorité la plus élevée)
      if (productTitle.toLowerCase().includes('body')) {
        console.log("Produit détecté comme un BODY");
        this.productType = 'body';
      } 
      // Vérifier s'il s'agit d'un ensemble
      else {
        const ensemblePatterns = ['deux pièces', 'trois pièces', 'quatre pièces', 'cinq pièces', 'ensemble'];
        for (const pattern of ensemblePatterns) {
          if (productTitle.toLowerCase().includes(pattern)) {
            console.log("Produit détecté comme un ENSEMBLE");
            this.productType = 'ensemble';
            break;
          }
        }
        
        // Par défaut pour les ambiguïtés, vérifier si la structure ressemble à un body
        if (!this.productType) {
          if (productTitle.toLowerCase().includes('ultra') || 
              productTitle.toLowerCase().includes('polyvalent') ||
              productTitle.toLowerCase().includes('pour femme')) {
            console.log("Produit présumé comme un BODY (par inférence)");
            this.productType = 'body';
          } else {
            // Fallback: vérifier les attributs de conteneur
            const container = document.querySelector('.naked-size-recommender');
            if (container && container.dataset.productType) {
              this.productType = container.dataset.productType;
            } else {
              // Détecter à partir des tags du produit comme second fallback
              const productTags = document.querySelector('meta[property="product:tag"]');
              if (productTags) {
                const tags = productTags.getAttribute('content').split(',');
                if (tags.includes('body')) {
                  this.productType = 'body';
                } else if (tags.includes('string') || tags.includes('ensemble')) {
                  this.productType = 'ensemble';
                }
              } else {
                // Par défaut, considérer comme un ensemble
                console.log("Produit considéré par défaut comme un ENSEMBLE");
                this.productType = 'ensemble';
              }
            }
          }
        }
      }
      
      // Ajouter les attributs data-product-type pour le CSS
      if (this.productType === 'body') {
        // Marquer explicitement le conteneur pour les règles CSS spécifiques aux body
        const container = document.querySelector('.naked-size-form-side');
        if (container) {
          container.setAttribute('data-product-type', 'body');
        }
        
        // S'assurer que tous les conteneurs d'étapes ont également l'attribut
        document.querySelectorAll('.naked-size-step').forEach(step => {
          step.setAttribute('data-product-type', 'body');
        });
      }
      
      return this.productType;
    }
    
    // Récupération de l'image du produit
    setProductImage() {
      // L'image est déjà définie via liquid dans le HTML
      const productImage = document.getElementById('naked-size-product-image');
      if (!productImage || !productImage.src) {
        // Fallback si l'image n'est pas définie correctement
        const productImages = document.querySelectorAll('.product__media img, .product-single__photo img, .product-featured-media img, .product-gallery__image img');
        
        if (productImages.length > 0) {
          const imageSrc = productImages[0].src;
          if (productImage && imageSrc) {
            productImage.src = imageSrc;
          }
        }
      }
    }
    
    // Initialisation des boutons de taille
    initializeSizeButtons() {
      this.initializeBraButtons();
      this.initializeBottomButtons();
    }
    
    // Initialisation des boutons pour le soutien-gorge
    initializeBraButtons() {
      const bandContainer = document.getElementById('band-size-buttons');
      const cupContainer = document.getElementById('cup-size-buttons');
      
      if (bandContainer && cupContainer) {
        // Générer les boutons pour le tour de dos
        let bandHTML = '';
        const euBands = config.sizingSystems.EU.bands;
        const rowSize = 5;
        
        for (let i = 0; i < euBands.length; i += rowSize) {
          const rowBands = euBands.slice(i, i + rowSize);
          const bandBtns = rowBands.map(band => 
            `<button type="button" class="naked-size-size-btn" data-band="${band}">${band}</button>`
          ).join('');
          
          bandHTML += bandBtns;
        }
        bandContainer.innerHTML = bandHTML;
        
        // Générer les boutons pour les bonnets
        let cupHTML = '';
        const euCups = config.sizingSystems.EU.cups;
        
        for (let i = 0; i < euCups.length; i += rowSize) {
          const rowCups = euCups.slice(i, i + rowSize);
          const cupBtns = rowCups.map(cup => 
            `<button type="button" class="naked-size-size-btn" data-cup="${cup}">${cup}</button>`
          ).join('');
          
          cupHTML += cupBtns;
        }
        cupContainer.innerHTML = cupHTML;
      }
    }
    
    // Initialisation des boutons pour le bas
    initializeBottomButtons() {
      const bottomContainer = document.getElementById('bottom-size-buttons');
      
      if (bottomContainer) {
        let bottomHTML = '';
        const euSizes = config.bottomSizes.EU;
        const rowSize = 5;
        
        for (let i = 0; i < euSizes.length; i += rowSize) {
          const rowSizes = euSizes.slice(i, i + rowSize);
          const sizeBtns = rowSizes.map(size => 
            `<button type="button" class="naked-size-size-btn" data-size="${size}">${size}</button>`
          ).join('');
          
          bottomHTML += sizeBtns;
        }
        bottomContainer.innerHTML = bottomHTML;
      }
    }
    
    // Mise à jour des boutons selon le système de taille
    updateSizeButtons(system) {
      // Mise à jour des boutons de tour de dos
      const bandButtons = document.querySelectorAll('#band-size-buttons .naked-size-size-btn');
      const bands = config.sizingSystems[system].bands;
      
      bandButtons.forEach((btn, index) => {
        if (index < bands.length) {
          btn.textContent = bands[index];
          btn.setAttribute('data-band', bands[index]);
          btn.style.display = 'inline-block';
        } else {
          btn.style.display = 'none';
        }
      });
      
      // Mise à jour des boutons de bonnets
      const cupButtons = document.querySelectorAll('#cup-size-buttons .naked-size-size-btn');
      const cups = config.sizingSystems[system].cups;
      
      cupButtons.forEach((btn, index) => {
        if (index < cups.length) {
          btn.textContent = cups[index];
          btn.setAttribute('data-cup', cups[index]);
          btn.style.display = 'inline-block';
        } else {
          btn.style.display = 'none';
        }
      });
      
      // Mise à jour des boutons de taille de bas
      const bottomButtons = document.querySelectorAll('#bottom-size-buttons .naked-size-size-btn');
      const sizes = config.bottomSizes[system];
      
      bottomButtons.forEach((btn, index) => {
        if (index < sizes.length) {
          btn.textContent = sizes[index];
          btn.setAttribute('data-size', sizes[index]);
          btn.style.display = 'inline-block';
        } else {
          btn.style.display = 'none';
        }
      });
    }
    
    // Configuration des écouteurs d'événements
    setupEventListeners() {
      console.log('Setting up event listeners');
      
      // IMPORTANT: Vérifier que le bouton existe
      if (!this.sizeButton) {
        console.error('Size button not found');
        return;
      }
      
      // Ouverture de la popup - CORRIGÉ
      this.sizeButton.addEventListener('click', (e) => {
        console.log('Size button clicked');
        
        // S'assurer que l'événement ne se propage pas
        e.preventDefault();
        e.stopPropagation();
        
        // Afficher la popup
        if (this.sizePopup) {
          this.sizePopup.style.display = 'flex';
          
          // Si on est sur mobile, ajouter les classes pour l'animation
          if (this.isMobile) {
            // Attendre le prochain frame pour que le display:flex soit appliqué
            requestAnimationFrame(() => {
              this.sizePopup.classList.add('active', 'fade-in');
              document.body.classList.add('size-popup-open');
            });
          }
        } else {
          console.error('Size popup element not found');
        }
      });
      
      // Fermeture de la popup avec le X
      const closeButton = document.querySelector('.naked-size-close-btn');
      if (closeButton) {
        closeButton.addEventListener('click', (e) => {
          console.log('Close button clicked');
          e.stopPropagation(); // Empêcher la propagation
          this.closePopup();
        });
      }
      
      // Fermeture en cliquant en dehors (uniquement le fond, pas le contenu)
      if (this.sizePopup) {
        this.sizePopup.addEventListener('click', (e) => {
          if (e.target === this.sizePopup) {
            this.closePopup();
          }
        });
      }
      
      // Configuration des unités, options morphologiques et sélecteurs
      this.setupUnitListeners();
      this.setupMorphologyListeners();
      this.setupSizeSelectors();
      this.setupNavigationListeners();
      
      // Étape 1 - Champs de base
      if (document.getElementById('naked-size-height')) {
        document.getElementById('naked-size-height').addEventListener('input', () => this.checkStep1Completion());
      }
      if (document.getElementById('naked-size-weight')) {
        document.getElementById('naked-size-weight').addEventListener('input', () => this.checkStep1Completion());
      }
      if (document.getElementById('naked-size-age')) {
        document.getElementById('naked-size-age').addEventListener('input', () => this.checkStep1Completion());
      }
      
      // Écouteur pour le redimensionnement de la fenêtre
      window.addEventListener('resize', () => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth <= 768;
        
        // Si on passe de non-mobile à mobile, initialiser les sliders et ajouter le bouton de fermeture
        if (!wasMobile && this.isMobile) {
          this.initializeMobileSliders();
          
          // Ajouter le bouton de fermeture s'il n'existe pas déjà
          if (!document.querySelector('.naked-size-close-btn')) {
            const closeButton = document.createElement('button');
            closeButton.className = 'naked-size-close-btn';
            closeButton.setAttribute('aria-label', window.nakedSizeT('close', 'Fermer'));
            
            const popupContent = this.sizePopup.querySelector('.naked-size-popup-content');
            if (popupContent) {
              popupContent.appendChild(closeButton);
              
              // Ajouter l'écouteur d'événement
              closeButton.addEventListener('click', (e) => {
                e.stopPropagation();
                this.closePopup();
              });
            }
          }
        }
      });
      
      // Exécuter la vérification initiale
      this.checkStep1Completion();
      this.checkStep2Completion();
      this.checkStep3Completion();
      this.checkStep4Completion();
      this.checkStep5Completion();
      this.checkStep6Completion();
    }
    
    // Configuration des écouteurs pour les unités
    setupUnitListeners() {
      const unitButtons = document.querySelectorAll('.naked-size-unit');
      unitButtons.forEach(button => {
        button.addEventListener('click', () => {
          // Trouver tous les boutons dans le même groupe
          const container = button.closest('.naked-size-units');
          if (container) {
            const siblingButtons = container.querySelectorAll('.naked-size-unit');
            
            // Désactiver tous les boutons du groupe
            siblingButtons.forEach(btn => btn.classList.remove('active'));
            
            // Activer ce bouton
            button.classList.add('active');
            
            // Si c'est un bouton pour changer d'unité de mesure principale
            if (button.getAttribute('data-unit') === 'cm' || button.getAttribute('data-unit') === 'feet') {
              this.currentUnit = button.getAttribute('data-unit') === 'cm' ? 'metric' : 'imperial';
              
              // Si on est sur mobile, mettre à jour le slider correspondant
              if (this.isMobile) {
                // Trouver le champ concerné
                const fieldContainer = container.closest('.naked-size-form-field');
                if (fieldContainer) {
                  const inputField = fieldContainer.querySelector('input[id^="naked-size-"]');
                  if (inputField) {
                    const fieldMatch = inputField.id.match(/naked-size-(\w+)/);
                    if (fieldMatch) {
                      const field = fieldMatch[1];
                      this.updateSliderUnit(field, this.currentUnit);
                      
                      // Mettre à jour également les boutons d'unité mobile si présents
                      const mobileUnits = fieldContainer.querySelector('.naked-size-units-mobile');
                      if (mobileUnits) {
                        const mobileButtons = mobileUnits.querySelectorAll('.naked-size-unit-mobile');
                        mobileButtons.forEach(btn => {
                          btn.classList.remove('active');
                          if (btn.getAttribute('data-unit') === button.getAttribute('data-unit')) {
                            btn.classList.add('active');
                          }
                        });
                      }
                    }
                  }
                }
              } else {
                // Version desktop: utiliser la méthode existante
                this.convertMeasurements();
              }
            }
          }
        });
      });
    }
    
    // Conversion des mesures selon l'unité
    convertMeasurements() {
      const heightInput = document.getElementById('naked-size-height');
      const weightInput = document.getElementById('naked-size-weight');
      
      if (heightInput.value && weightInput.value) {
        if (this.currentUnit === 'imperial') {
          // Convertir cm en pieds
          heightInput.value = (parseFloat(heightInput.value) / 30.48).toFixed(2);
          // Convertir kg en livres
          weightInput.value = (parseFloat(weightInput.value) * 2.20462).toFixed(1);
        } else {
          // Convertir pieds en cm
          heightInput.value = Math.round(parseFloat(heightInput.value) * 30.48);
          // Convertir livres en kg
          weightInput.value = Math.round(parseFloat(weightInput.value) / 2.20462);
        }
      }
    }
    
    // Configuration des options morphologiques
    setupMorphologyListeners() {
      // Étape 2 - Sélection du ventre
      document.querySelectorAll('.naked-size-step[data-step="2"] .naked-size-morphology-option').forEach(option => {
        option.addEventListener('click', () => {
          // Le code existant pour sélectionner l'option
          document.querySelectorAll('.naked-size-step[data-step="2"] .naked-size-morphology-option').forEach(opt => 
            opt.classList.remove('selected')
          );
          option.classList.add('selected');
          this.userData.stomach = option.getAttribute('data-value');
          
          // Ajouter la vérification
          this.checkStep2Completion();
        });
      });
      
      // Étape 3 - Sélection des hanches
      document.querySelectorAll('.naked-size-step[data-step="3"] .naked-size-morphology-option').forEach(option => {
        option.addEventListener('click', () => {
          // Le code existant pour sélectionner l'option
          document.querySelectorAll('.naked-size-step[data-step="3"] .naked-size-morphology-option').forEach(opt => 
            opt.classList.remove('selected')
          );
          option.classList.add('selected');
          this.userData.hips = option.getAttribute('data-value');
          
          // Ajouter la vérification
          this.checkStep3Completion();
        });
      });
      
      // Étape 4 - Sélection des fesses
      document.querySelectorAll('.naked-size-step[data-step="4"] .naked-size-morphology-option').forEach(option => {
        option.addEventListener('click', () => {
          // Le code existant pour sélectionner l'option
          document.querySelectorAll('.naked-size-step[data-step="4"] .naked-size-morphology-option').forEach(opt => 
            opt.classList.remove('selected')
          );
          option.classList.add('selected');
          this.userData.seat = option.getAttribute('data-value');
          
          // Ajouter la vérification
          this.checkStep4Completion();
        });
      });
    }
    
    setupSizeSelectors() {
      // Système de taille de soutien-gorge
      const braSizeSystem = document.getElementById('bra-size-system');
      if (braSizeSystem) {
        braSizeSystem.addEventListener('change', () => {
          this.userData.braSize.system = braSizeSystem.value;
          this.updateSizeButtons(braSizeSystem.value);
          
          // Réinitialiser la sélection
          const bandButtons = document.querySelectorAll('#band-size-buttons .naked-size-size-btn');
          if (bandButtons.length > 0) {
            bandButtons.forEach(btn => {
              btn.classList.remove('selected');
            });
          }
          
          const cupButtons = document.querySelectorAll('#cup-size-buttons .naked-size-size-btn');
          if (cupButtons.length > 0) {
            cupButtons.forEach(btn => {
              btn.classList.remove('selected');
            });
          }
          
          this.userData.braSize.band = null;
          this.userData.braSize.cup = null;
          
          this.checkStep5Completion();
        });
      }
      
      // Étape 5 - Boutons de tour de dos
      document.addEventListener('click', (e) => {
        if (e.target && e.target.matches && e.target.matches('#band-size-buttons .naked-size-size-btn')) {
          const bandButtons = document.querySelectorAll('#band-size-buttons .naked-size-size-btn');
          if (bandButtons.length > 0) {
            bandButtons.forEach(btn => {
              btn.classList.remove('selected');
            });
          }
          
          e.target.classList.add('selected');
          this.userData.braSize.band = parseInt(e.target.getAttribute('data-band'));
          this.checkStep5Completion();
        }
      });
      
      // Étape 5 - Boutons de bonnet
      document.addEventListener('click', (e) => {
        if (e.target && e.target.matches && e.target.matches('#cup-size-buttons .naked-size-size-btn')) {
          const cupButtons = document.querySelectorAll('#cup-size-buttons .naked-size-size-btn');
          if (cupButtons.length > 0) {
            cupButtons.forEach(btn => {
              btn.classList.remove('selected');
            });
          }
          
          e.target.classList.add('selected');
          this.userData.braSize.cup = e.target.getAttribute('data-cup');
          this.checkStep5Completion();
        }
      });
      
      // Système de taille de bas
      const bottomSizeSystem = document.getElementById('bottom-size-system');
      if (bottomSizeSystem) {
        bottomSizeSystem.addEventListener('change', () => {
          this.userData.bottomSize.system = bottomSizeSystem.value;
          this.updateSizeButtons(bottomSizeSystem.value);
          
          // Réinitialiser la sélection
          const bottomButtons = document.querySelectorAll('#bottom-size-buttons .naked-size-size-btn');
          if (bottomButtons.length > 0) {
            bottomButtons.forEach(btn => {
              btn.classList.remove('selected');
            });
          }
          
          this.userData.bottomSize.size = null;
          
          this.checkStep6Completion();
        });
      }
      
      // Étape 6 - Boutons de taille de bas
      document.addEventListener('click', (e) => {
        if (e.target && e.target.matches && e.target.matches('#bottom-size-buttons .naked-size-size-btn')) {
          const bottomButtons = document.querySelectorAll('#bottom-size-buttons .naked-size-size-btn');
          if (bottomButtons.length > 0) {
            bottomButtons.forEach(btn => {
              btn.classList.remove('selected');
            });
          }
          
          e.target.classList.add('selected');
          this.userData.bottomSize.size = parseInt(e.target.getAttribute('data-size'));
          
          this.checkStep6Completion();
        }
      });
    }
    
    // Configuration des boutons de navigation
    setupNavigationListeners() {
      // Étape 1: Informations de base -> Étape 2: Ventre
      document.getElementById('step1-next').addEventListener('click', () => {
        if (!this.validateStep1()) {
          alert(window.nakedSizeT('fill_all_fields', 'Veuillez remplir correctement tous les champs.'));
          return;
        }
        this.goToStep(2);
      });
      
      // Étape 2: Ventre - Navigation
      document.getElementById('step2-prev').addEventListener('click', () => {
        this.goToStep(1);
      });
      document.getElementById('step2-next').addEventListener('click', () => {
        if (!this.userData.stomach) {
          alert(window.nakedSizeT('select_option', 'Veuillez sélectionner une option.'));
          return;
        }
        this.goToStep(3);
      });
      
      // Étape 3: Hanches - Navigation
      document.getElementById('step3-prev').addEventListener('click', () => {
        this.goToStep(2);
      });
      document.getElementById('step3-next').addEventListener('click', () => {
        if (!this.userData.hips) {
          alert(window.nakedSizeT('select_option', 'Veuillez sélectionner une option.'));
          return;
        }
        this.goToStep(4);
      });
      
      // Étape 4: Fesses - Navigation
      document.getElementById('step4-prev').addEventListener('click', () => {
        this.goToStep(3);
      });
      document.getElementById('step4-next').addEventListener('click', () => {
        if (!this.userData.seat) {
          alert(window.nakedSizeT('select_option', 'Veuillez sélectionner une option.'));
          return;
        }
        this.goToStep(5);
      });
      
      // Étape 5: Taille de soutien-gorge - Navigation
      document.getElementById('step5-prev').addEventListener('click', () => {
        this.goToStep(4);
      });
      document.getElementById('step5-next').addEventListener('click', () => {
        if (!this.userData.braSize.band || !this.userData.braSize.cup) {
          alert(window.nakedSizeT('select_band_cup', 'Veuillez sélectionner une taille de tour de dos et un bonnet.'));
          return;
        }
        this.goToStep(6);
      });
      
      // Étape 6: Taille de bas - Navigation
      document.getElementById('step6-prev').addEventListener('click', () => {
        this.goToStep(5);
      });
      document.getElementById('step6-next').addEventListener('click', () => {
        if (!this.userData.bottomSize.size) {
          alert(window.nakedSizeT('select_bottom_size', 'Veuillez sélectionner une taille de bas.'));
          return;
        }
        this.showResults();
      });
      
      // Étape 7: Résultats - Navigation
      document.getElementById('step7-edit').addEventListener('click', () => {
        this.goToStep(1);
      });
      document.getElementById('step7-apply').addEventListener('click', () => {
        // Sauvegarde des données avant d'appliquer la taille
        this.applyRecommendedSize();
      });
    }
    
    // Validation de l'étape 1
    validateStep1() {
      const heightInput = document.getElementById('naked-size-height');
      const weightInput = document.getElementById('naked-size-weight');
      const ageInput = document.getElementById('naked-size-age');
      
      if (!heightInput.value || !weightInput.value || !ageInput.value) {
        return false;
      }
      
      // Convertir les valeurs en nombres
      let height = parseFloat(heightInput.value);
      let weight = parseFloat(weightInput.value);
      let age = parseInt(ageInput.value);
      
      if (isNaN(height) || isNaN(weight) || isNaN(age)) {
        return false;
      }
      
      // Convertir si en unités impériales
      if (this.currentUnit === 'imperial') {
        // Pieds en cm
        height = height * 30.48;
        // Livres en kg
        weight = weight * 0.453592;
      }
      
      // Stocker les valeurs converties
      this.userData.height = height;
      this.userData.weight = weight;
      this.userData.age = age;
      
      return true;
    }
    
    // Navigation entre les étapes
    goToStep(step) {
      // Masquer toutes les étapes
      document.querySelectorAll('.naked-size-step').forEach(el => {
        el.classList.remove('active');
        el.style.display = 'none';
      });
      
      // Afficher l'étape demandée
      const targetStep = document.querySelector(`.naked-size-step[data-step="${step}"]`);
      if (targetStep) {
        targetStep.classList.add('active');
        targetStep.style.display = 'flex';
        this.currentStep = step;
        this.updateProgressDots(step);
      }
    }
    
    // Mise à jour des indicateurs de progression
    updateProgressDots(step) {
      this.progressDots.forEach((dot, index) => {
        if (index < step) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
    
    /**
     * ===== NOUVEL ALGORITHME DE RECOMMANDATION DE TAILLES =====
     * Méthode principale pour calculer les tailles recommandées avec une nouvelle approche plus réaliste
     */
    calculateRecommendedSizes() {
      console.log("Calcul des tailles recommandées avec l'algorithme amélioré");
      
      // 1. Convertir toutes les tailles en système EU
      const euBraSize = this.convertBraSizeToEU(this.userData.braSize);
      const euBottomSize = this.convertBottomSizeToEU(this.userData.bottomSize);
      
      console.log(`Taille de soutien-gorge EU: ${euBraSize.band}${euBraSize.cup}`);
      console.log(`Taille de bas EU: ${euBottomSize}`);
      
      // 2. Calculer l'IMC (pour l'utiliser dans plusieurs calculs)
      const bmi = this.calculateBMI(this.userData.height, this.userData.weight);
      console.log(`IMC: ${bmi.toFixed(2)}`);
      
      // 3. Calculer les scores pour chaque taille
      const topScores = this.calculateTopScores(euBraSize, bmi);
      const bottomScores = this.calculateBottomScores(euBottomSize, bmi);
      
      console.log("Scores pour le haut:", topScores);
      console.log("Scores pour le bas:", bottomScores);
      
      // 4. Déterminer les tailles optimales
      const topSize = this.getHighestScoringSize(topScores);
      const bottomSize = this.getHighestScoringSize(bottomScores);
      
      console.log(`Taille recommandée pour le haut: ${topSize}`);
      console.log(`Taille recommandée pour le bas: ${bottomSize}`);
      
      // 5. Pour les body, déterminer une taille unique cohérente
      let bodySize = null;
      if (this.productType === 'body') {
        bodySize = this.calculateBodySize(topSize, bottomSize, euBraSize, euBottomSize);
        console.log(`Taille pour le body: ${bodySize}`);
      }
      
      // 6. Calculer la confiance dans la recommandation
      const confidence = this.calculateConfidence(topScores, bottomScores, topSize, bottomSize);
      console.log(`Niveau de confiance: ${confidence}%`);
      
      // Retourner le résultat complet
      return {
        top: topSize,
        bottom: bottomSize,
        bodySize: bodySize,
        confidence: confidence
      };
    }
    
    /**
     * Calcule l'IMC
     */
    calculateBMI(height, weight) {
      const heightInMeters = height / 100;
      return weight / (heightInMeters * heightInMeters);
    }
    
    /**
     * Calcule les scores pour le haut basé sur plusieurs facteurs
     */
    calculateTopScores(euBraSize, bmi) {
      const scores = { 'S': 0, 'M': 0, 'L': 0, 'XL': 0 };
      
      // 1. Matrice de correspondance soutien-gorge → taille (80%)
      const matrixScores = this.getTopSizeFromBra(euBraSize.band, euBraSize.cup);
      Object.keys(scores).forEach(size => {
        scores[size] += matrixScores[size] * this.factors.top.braSizeMatrix;
      });
      
      // 2. Influence de l'IMC (10%)
      const bmiScores = this.getBmiScoresForTop(bmi);
      Object.keys(scores).forEach(size => {
        scores[size] += bmiScores[size] * this.factors.top.bmi;
      });
      
      // 3. Influence de la morphologie (5%)
      if (this.userData.stomach) {
        const morphologyScores = this.getStomachScores(this.userData.stomach);
        Object.keys(scores).forEach(size => {
          scores[size] += morphologyScores[size] * this.factors.top.morphology;
        });
      }
      
      // 4. Influence de l'âge (5%)
      const ageScores = this.getAgeScores(this.userData.age);
      Object.keys(scores).forEach(size => {
        scores[size] += ageScores[size] * this.factors.top.age;
      });
      
      return scores;
    }
    
    /**
     * Calcule les scores pour le bas basé sur plusieurs facteurs
     */
    calculateBottomScores(euBottomSize, bmi) {
      const scores = { 'S': 0, 'M': 0, 'L': 0, 'XL': 0 };
      
      // 1. Matrice de correspondance taille EU → taille (75%)
      const matrixScores = this.getBottomSizeFromEu(euBottomSize);
      Object.keys(scores).forEach(size => {
        scores[size] += matrixScores[size] * this.factors.bottom.euSizeMatrix;
      });
      
      // 2. Influence de l'IMC (15%)
      const bmiScores = this.getBmiScoresForBottom(bmi);
      Object.keys(scores).forEach(size => {
        scores[size] += bmiScores[size] * this.factors.bottom.bmi;
      });
      
      // 3. Influence de la morphologie (5%)
      const morphologyScores = this.getBottomMorphologyScores();
      Object.keys(scores).forEach(size => {
        scores[size] += morphologyScores[size] * this.factors.bottom.morphology;
      });
      
      // 4. Influence des proportions (5%)
      const proportionScores = this.getProportionScores();
      Object.keys(scores).forEach(size => {
        scores[size] += proportionScores[size] * this.factors.bottom.proportions;
      });
      
      return scores;
    }
    
    /**
     * Détermine la taille de haut à partir du soutien-gorge
     * Implémentation basée sur une matrice de correspondance réaliste
     */
    getTopSizeFromBra(band, cup) {
      // Scores par défaut
      const scores = { 'S': 0, 'M': 0, 'L': 0, 'XL': 0 };
      
      // Conversion du bonnet en valeur numérique
      const cupValues = {
        'AA': 0, 'A': 1, 'B': 2, 'C': 3, 'D': 4, 
        'E': 5, 'F': 6, 'G': 7, 'H': 8
      };
      const cupValue = cupValues[cup] || 3; // Défaut à C si non trouvé
      
      // MATRICE DE CORRESPONDANCE EMPIRIQUE RÉALISTE
      
      // AA-B (petits bonnets)
      if (cupValue <= 2) {
        if (band <= 90) {
          // Tour de dos jusqu'à 90 avec petits bonnets = S
          scores['S'] = 1.0;
        } else if (band <= 105) {
          // Tour de dos 95-105 avec petits bonnets = M
          scores['M'] = 1.0;
        } else {
          // Tour de dos 110+ avec petits bonnets = L
          scores['L'] = 1.0;
        }
      }
      
      // C (bonnet moyen)
      else if (cupValue === 3) {
        if (band <= 90) {
          // Tour de dos jusqu'à 90 avec bonnet C = S
          scores['S'] = 1.0;
        } else if (band <= 105) {
          // Tour de dos 95-105 avec bonnet C = M
          scores['M'] = 1.0;
        } else {
          // Tour de dos 110+ avec bonnet C = L
          scores['L'] = 1.0;
        }
      }
      
      // D (bonnet moyen-grand)
      else if (cupValue === 4) {
        if (band <= 85) {
          // Tour de dos jusqu'à 85 avec bonnet D = S/M
          scores['S'] = 0.3;
          scores['M'] = 0.7;
        } else if (band <= 95) {
          // Tour de dos 90-95 avec bonnet D = M/L
          scores['M'] = 0.3;
          scores['L'] = 0.7;
        } else if (band <= 105) {
          // Tour de dos 100-105 avec bonnet D = L
          scores['L'] = 1.0;
        } else {
          // Tour de dos 110+ avec bonnet D = XL
          scores['XL'] = 1.0;
        }
      }
      
      // E (grand bonnet)
      else if (cupValue === 5) {
        if (band <= 85) {
          // Tour de dos jusqu'à 85 avec bonnet E = M
          scores['M'] = 1.0;
        } else if (band <= 95) {
          // Tour de dos 90-95 avec bonnet E = L
          scores['L'] = 1.0;
        } else {
          // Tour de dos 100+ avec bonnet E = XL
          scores['XL'] = 1.0;
        }
      }
      
      // F+ (très grands bonnets)
      else {
        if (band <= 85) {
          // Tour de dos jusqu'à 85 avec bonnets F+ = L
          scores['L'] = 1.0;
        } else {
          // Tour de dos 90+ avec bonnets F+ = XL
          scores['XL'] = 1.0;
        }
      }
      
      // *** ZONES DE TRANSITION FLUIDE ***
      // Pour éviter les effets de falaise, appliquer une transition douce aux limites des intervalles
      
      // Transition pour les petits bonnets (AA-B)
      if (cupValue <= 2) {
        if (band === 90) {
          // Transition 90B entre S et M
          scores['S'] = 0.6;
          scores['M'] = 0.4;
        }
      }
      
      // Transition pour le bonnet C
      if (cupValue === 3) {
        if (band === 90) {
          // Transition 90C entre S et M
          scores['S'] = 0.4;
          scores['M'] = 0.6;
        }
      }
      
      // Transition pour le bonnet D
      if (cupValue === 4) {
        if (band === 85) {
          // Transition 85D entre S et M (favorisant M)
          scores['S'] = 0.3;
          scores['M'] = 0.7;
        } else if (band === 95) {
          // Transition 95D entre M et L (favorisant L)
          scores['M'] = 0.3;
          scores['L'] = 0.7;
        }
      }
      
      return scores;
    }
    
    /**
     * Détermine la taille de bas à partir de la taille EU
     */
    getBottomSizeFromEu(euSize) {
      const scores = { 'S': 0, 'M': 0, 'L': 0, 'XL': 0 };
      
      // Correspondance directe des tailles
      if (euSize <= 36) {
        scores['S'] = 1.0;
      } else if (euSize <= 40) {
        scores['M'] = 1.0;
      } else if (euSize <= 44) {
        scores['L'] = 1.0;
      } else {
        scores['XL'] = 1.0;
      }
      
      // Zone de transition pour les tailles limites
      if (euSize === 36) {
        // Transition 36 entre S et M
        scores['S'] = 0.7;
        scores['M'] = 0.3;
      } else if (euSize === 38) {
        // Transition 38 entre S et M
        scores['S'] = 0.3;
        scores['M'] = 0.7;
      } else if (euSize === 40) {
        // Transition 40 entre M et L
        scores['M'] = 0.7;
        scores['L'] = 0.3;
      } else if (euSize === 42) {
        // Transition 42 entre M et L
        scores['M'] = 0.3;
        scores['L'] = 0.7;
      } else if (euSize === 44) {
        // Transition 44 entre L et XL
        scores['L'] = 0.7;
        scores['XL'] = 0.3;
      } else if (euSize === 46) {
        // Transition 46 entre L et XL
        scores['L'] = 0.3;
        scores['XL'] = 0.7;
      }
      
      return scores;
    }
    
    /**
     * Calcule les scores selon l'IMC pour le haut
     */
    getBmiScoresForTop(bmi) {
      const scores = { 'S': 0, 'M': 0, 'L': 0, 'XL': 0 };
      
      // Distribution des scores selon l'IMC
      if (bmi < 18.5) {
        // IMC sous-poids: forte tendance S
        scores['S'] = 0.9;
        scores['M'] = 0.1;
      } else if (bmi < 20) {
        // IMC mince: tendance S
        scores['S'] = 0.7;
        scores['M'] = 0.3;
      } else if (bmi < 22) {
        // IMC normal bas: S-M
        scores['S'] = 0.5;
        scores['M'] = 0.5;
      } else if (bmi < 25) {
        // IMC normal: M
        scores['S'] = 0.2;
        scores['M'] = 0.8;
      } else if (bmi < 28) {
        // IMC normal haut: M-L
        scores['M'] = 0.7;
        scores['L'] = 0.3;
      } else if (bmi < 30) {
        // IMC surpoids: L
        scores['M'] = 0.3;
        scores['L'] = 0.7;
      } else if (bmi < 35) {
        // IMC obésité modérée: L
        scores['L'] = 0.9;
        scores['XL'] = 0.1;
      } else {
        // IMC obésité: XL
        scores['L'] = 0.2;
        scores['XL'] = 0.8;
      }
      
      return scores;
    }
    
    /**
     * Calcule les scores selon l'IMC pour le bas
     */
    getBmiScoresForBottom(bmi) {
      const scores = { 'S': 0, 'M': 0, 'L': 0, 'XL': 0 };
      
      // Distribution similaire au haut, avec quelques ajustements
      if (bmi < 18.5) {
        // IMC sous-poids: forte tendance S
        scores['S'] = 0.9;
        scores['M'] = 0.1;
      } else if (bmi < 20) {
        // IMC mince: tendance S
        scores['S'] = 0.7;
        scores['M'] = 0.3;
      } else if (bmi < 22) {
        // IMC normal bas: S-M
        scores['S'] = 0.4;
        scores['M'] = 0.6;
      } else if (bmi < 25) {
        // IMC normal: M
        scores['M'] = 1.0;
      } else if (bmi < 28) {
        // IMC normal haut: M-L
        scores['M'] = 0.6;
        scores['L'] = 0.4;
      } else if (bmi < 30) {
        // IMC surpoids: L
        scores['M'] = 0.2;
        scores['L'] = 0.8;
      } else if (bmi < 35) {
        // IMC obésité modérée: L
        scores['L'] = 0.8;
        scores['XL'] = 0.2;
      } else {
        // IMC obésité: XL
        scores['L'] = 0.1;
        scores['XL'] = 0.9;
      }
      
      return scores;
    }
    
    /**
     * Calcule les scores selon la forme du ventre (influence limitée)
     */
    getStomachScores(stomach) {
      const scores = { 'S': 0, 'M': 0, 'L': 0, 'XL': 0 };
      
      // Influence plus faible que dans l'ancien algorithme
      switch (stomach) {
        case 'flat':
          // Ventre plat: légère tendance vers S
          scores['S'] = 0.6;
          scores['M'] = 0.4;
          break;
        case 'average':
          // Ventre moyen: équilibré
          scores['S'] = 0.3;
          scores['M'] = 0.7;
          break;
        case 'round':
          // Ventre rond: légère tendance vers M
          scores['M'] = 0.8;
          scores['L'] = 0.2;
          break;
        default:
          // Valeur par défaut
          scores['S'] = 0.25;
          scores['M'] = 0.5;
          scores['L'] = 0.25;
      }
      
      return scores;
    }
    
    /**
     * Calcule les scores de morphologie pour le bas
     */
    getBottomMorphologyScores() {
      const scores = { 'S': 0, 'M': 0, 'L': 0, 'XL': 0 };
      
      // Influence des hanches (50%)
      let hipsInfluence = { 'S': 0, 'M': 0, 'L': 0, 'XL': 0 };
      if (this.userData.hips === 'narrow') {
        hipsInfluence['S'] = 0.6;
        hipsInfluence['M'] = 0.4;
      } else if (this.userData.hips === 'average') {
        hipsInfluence['S'] = 0.3;
        hipsInfluence['M'] = 0.7;
      } else if (this.userData.hips === 'curved') {
        hipsInfluence['M'] = 0.7;
        hipsInfluence['L'] = 0.3;
      } else {
        // Valeur par défaut
        hipsInfluence['S'] = 0.25;
        hipsInfluence['M'] = 0.5;
        hipsInfluence['L'] = 0.25;
      }
      
      // Influence des fesses (50%)
      let seatInfluence = { 'S': 0, 'M': 0, 'L': 0, 'XL': 0 };
      if (this.userData.seat === 'flat') {
        seatInfluence['S'] = 0.6;
        seatInfluence['M'] = 0.4;
      } else if (this.userData.seat === 'average') {
        seatInfluence['S'] = 0.3;
        seatInfluence['M'] = 0.7;
      } else if (this.userData.seat === 'round') {
        seatInfluence['M'] = 0.7;
        seatInfluence['L'] = 0.3;
      } else {
        // Valeur par défaut
        seatInfluence['S'] = 0.25;
        seatInfluence['M'] = 0.5;
        seatInfluence['L'] = 0.25;
      }
      
      // Combinaison des influences
      Object.keys(scores).forEach(size => {
        scores[size] = (hipsInfluence[size] || 0) * 0.5 + (seatInfluence[size] || 0) * 0.5;
      });
      
      return scores;
    }
    
    /**
     * Calcule les scores selon l'âge
     */
    getAgeScores(age) {
      const scores = { 'S': 0, 'M': 0, 'L': 0, 'XL': 0 };
      
      // L'âge a une influence mineure
      if (!age) {
        // Par défaut si l'âge n'est pas spécifié
        scores['S'] = 0.25;
        scores['M'] = 0.5;
        scores['L'] = 0.25;
        return scores;
      }
      
      if (age < 25) {
        // Jeunes adultes: tendance légèrement S
        scores['S'] = 0.6;
        scores['M'] = 0.4;
      } else if (age < 40) {
        // Adultes: tendance M
        scores['S'] = 0.2;
        scores['M'] = 0.8;
      } else if (age < 60) {
        // Adultes matures: tendance M-L
        scores['M'] = 0.6;
        scores['L'] = 0.4;
      } else {
        // Seniors: tendance L
        scores['M'] = 0.3;
        scores['L'] = 0.7;
      }
      
      return scores;
    }
    
    /**
     * Calcule les scores selon les proportions générales
     */
    getProportionScores() {
      const scores = { 'S': 0, 'M': 0, 'L': 0, 'XL': 0 };
      
      // Par défaut si les données sont insuffisantes
      if (!this.userData.height || !this.userData.weight) {
        scores['M'] = 1.0;
        return scores;
      }
      
      // Rapport taille/hauteur (simplification des proportions)
      const ratio = this.userData.weight / (this.userData.height / 100);
      
      if (ratio < 0.35) {
        // Très mince: tendance S
        scores['S'] = 0.9;
        scores['M'] = 0.1;
      } else if (ratio < 0.4) {
        // Mince: S-M
        scores['S'] = 0.6;
        scores['M'] = 0.4;
      } else if (ratio < 0.45) {
        // Normal mince: M avec légère tendance S
        scores['S'] = 0.3;
        scores['M'] = 0.7;
      } else if (ratio < 0.5) {
        // Normal: M
        scores['M'] = 1.0;
      } else if (ratio < 0.55) {
        // Normal fort: M avec légère tendance L
        scores['M'] = 0.7;
        scores['L'] = 0.3;
      } else if (ratio < 0.6) {
        // Fort: M-L
        scores['M'] = 0.4;
        scores['L'] = 0.6;
      } else if (ratio < 0.7) {
        // Très fort: L
        scores['L'] = 0.9;
        scores['XL'] = 0.1;
      } else {
        // Extra fort: L-XL
        scores['L'] = 0.3;
        scores['XL'] = 0.7;
      }
      
      return scores;
    }
    
    /**
     * Détermine la taille pour un body en tenant compte du haut et du bas
     */
    calculateBodySize(topSize, bottomSize, euBraSize, euBottomSize) {
      // Pour les body, le problème est plus complexe car il faut un compromis
      // entre le haut et le bas
      
      // Conversion en valeurs numériques pour faciliter la comparaison
      const sizeRank = { 'S': 0, 'M': 1, 'L': 2, 'XL': 3 };
      const topRank = sizeRank[topSize];
      const bottomRank = sizeRank[bottomSize];
      
      // Si les tailles sont identiques, c'est simple
      if (topSize === bottomSize) {
        return topSize;
      }
      
      // Si l'écart est d'une seule taille, prendre en compte le tour de dos et la taille EU
      if (Math.abs(topRank - bottomRank) === 1) {
        // Facteurs qui font pencher vers le haut ou le bas
        const cupValues = { 'AA': 0, 'A': 1, 'B': 2, 'C': 3, 'D': 4, 'E': 5, 'F': 6 };
        const cupValue = cupValues[euBraSize.cup] || 3;
        
        // Les grands bonnets font pencher vers le haut
        const largeCup = cupValue >= 4;
        
        // Les petites tailles EU font pencher vers le bas
        const smallBottom = euBottomSize <= 38;
        
        // Si les deux facteurs sont contradictoires, prendre la taille la plus grande
        if (largeCup && smallBottom) {
          return topRank > bottomRank ? topSize : bottomSize;
        }
        
        // Sinon, suivre les facteurs
        if (largeCup) {
          return topSize;
        }
        if (smallBottom) {
          return bottomSize;
        }
        
        // Par défaut pour un body, privilégier la taille la plus grande
        return topRank > bottomRank ? topSize : bottomSize;
      }
      
      // Si l'écart est important (2 tailles ou plus), prendre une taille intermédiaire
      if (Math.abs(topRank - bottomRank) >= 2) {
        const avgRank = Math.round((topRank + bottomRank) / 2);
        const sizes = ['S', 'M', 'L', 'XL'];
        return sizes[avgRank];
      }
      
      // En cas de doute, privilégier la taille du haut
      return topSize;
    }
    
    /**
     * Obtient la taille avec le score le plus élevé
     */
    getHighestScoringSize(scores) {
      let bestSize = 'M'; // Taille par défaut
      let bestScore = 0;
      
      Object.keys(scores).forEach(size => {
        if (scores[size] > bestScore) {
          bestScore = scores[size];
          bestSize = size;
        }
      });
      
      return bestSize;
    }
    
    /**
     * Calcule le niveau de confiance dans la recommandation
     */
    calculateConfidence(topScores, bottomScores, topSize, bottomSize) {
      // Calcul basé sur l'écart entre le meilleur score et le second
      
      // Pour le haut
      let topScoresSorted = Object.entries(topScores)
        .sort((a, b) => b[1] - a[1]);
      
      const topConfidence = topScoresSorted.length > 1
        ? Math.min(100, 50 + 50 * (topScoresSorted[0][1] - topScoresSorted[1][1]))
        : 75;
      
      // Pour le bas
      let bottomScoresSorted = Object.entries(bottomScores)
        .sort((a, b) => b[1] - a[1]);
      
      const bottomConfidence = bottomScoresSorted.length > 1
        ? Math.min(100, 50 + 50 * (bottomScoresSorted[0][1] - bottomScoresSorted[1][1]))
        : 75;
      
      // Moyenne des deux confiances
      return Math.round((topConfidence + bottomConfidence) / 2);
    }
    
    /**
     * Convertit une taille de soutien-gorge vers EU
     */
    convertBraSizeToEU(braSize) {
      const { band, cup, system } = braSize;
      
      if (system === 'EU') {
        return { band, cup };
      }
      
      let euBand, euCup;
      
      // Conversion du tour de dos
      if (system === 'UK' || system === 'US') {
        euBand = band * 2 + 4;
      } else if (system === 'AUS') {
        euBand = band * 5 + 30;
      }
      
      // Conversion du bonnet
      const cupIndex = config.sizingSystems[system].cups.indexOf(cup);
      euCup = config.sizingSystems.EU.cups[cupIndex];
      
      return { band: euBand, cup: euCup };
    }
    
    /**
     * Convertit une taille de bas vers EU
     */
    convertBottomSizeToEU(bottomSize) {
      const { size, system } = bottomSize;
      
      if (system === 'EU') {
        return size;
      }
      
      const sizeIndex = config.bottomSizes[system].indexOf(size);
      return config.bottomSizes.EU[sizeIndex];
    }
    
    // Affichage des résultats
    showResults() {
      const recommendation = this.calculateRecommendedSizes();
      const isBody = this.productType === 'body';
      
      // Sélectionner les conteneurs appropriés
      const bodyResultContainer = document.querySelector('.naked-size-result-body');
      const ensembleResultContainer = document.querySelector('.naked-size-result-ensemble');
      
      // Si les conteneurs spécifiques existent, les afficher selon le type de produit
      if (bodyResultContainer && ensembleResultContainer) {
        // Afficher le conteneur approprié
        bodyResultContainer.style.display = isBody ? 'block' : 'none';
        ensembleResultContainer.style.display = isBody ? 'none' : 'block';
        
        // Mettre à jour les tailles selon le type de produit
        if (isBody) {
          const bodySize = recommendation.bodySize || recommendation.top;
          document.getElementById('naked-size-body-size').textContent = bodySize;
        } else {
          document.getElementById('naked-size-top-size').textContent = recommendation.top;
          document.getElementById('naked-size-bottom-size').textContent = recommendation.bottom;
        }
        
        // Mettre à jour le message de preuve sociale
        this.updateSocialProofMessage(this.productType);
      } else {
        // Fallback pour la compatibilité avec l'ancien HTML
        // Récupérer les éléments traditionnels
        const topSizeElement = document.getElementById('naked-size-top-size');
        const bottomSizeElement = document.getElementById('naked-size-bottom-size');
        
        if (topSizeElement && bottomSizeElement) {
          if (isBody) {
            const bodySize = recommendation.bodySize || recommendation.top;
            topSizeElement.textContent = bodySize;
            bottomSizeElement.textContent = bodySize;
            
            // Ajouter des attributs pour les styles CSS
            const resultStep = document.querySelector('.naked-size-step[data-step="7"]');
            if (resultStep) {
              resultStep.setAttribute('data-product-type', 'body');
            }
          } else {
            topSizeElement.textContent = recommendation.top;
            bottomSizeElement.textContent = recommendation.bottom;
          }
        }
      }
      
      // Afficher l'étape des résultats
      this.goToStep(7);
      
      // Mise à jour du texte du bouton d'application
      const applyButton = document.getElementById('step7-apply');
      if (applyButton) {
        // On utilise maintenant Continuer comme texte
        applyButton.textContent = window.nakedSizeT('continue', 'Continuer');
        
        if (isBody) {
          const bodySize = recommendation.bodySize || recommendation.top;
          applyButton.setAttribute('aria-label', `${window.nakedSizeT('apply_size_aria', 'Appliquer la taille')} ${bodySize}`);
        }
      }
    }
    
    // Nouvelle méthode pour afficher le message de preuve sociale
    updateSocialProofMessage(productType) {
      // Sélecteur pour le message en fonction du type de produit
      const socialProofText = productType === 'body' 
        ? document.getElementById('naked-size-body-social-proof')
        : document.getElementById('naked-size-ensemble-social-proof');
      
      if (!socialProofText) return;
      
      // Utiliser le message prédéfini dans la configuration
      const messageKey = productType === 'body' ? 'body' : 'ensemble';
      socialProofText.textContent = config.socialProofMessages[messageKey];
    }
    
    // Méthode pour fermer la popup avec animation
    closePopup() {
      console.log('Closing popup');
      
      // Vérifier si l'étape 7 (résultats) est active avant de sauvegarder
      const resultStep = document.querySelector('.naked-size-step[data-step="7"]');
      if (resultStep && resultStep.classList.contains('active')) {
        console.log("Sauvegarde des données lors de la fermeture de la popup");
        this.saveUserData();
      }
      
      if (this.isMobile) {
        // Animation de fermeture
        this.sizePopup.classList.remove('fade-in');
        this.sizePopup.classList.add('fade-out');
        
        // Attendre la fin de l'animation avant de cacher la popup
        setTimeout(() => {
          this.sizePopup.classList.remove('active', 'fade-out');
          this.sizePopup.style.display = 'none';
          document.body.classList.remove('size-popup-open');
        }, 300); // Correspond à la durée de l'animation
      } else {
        // Comportement standard pour desktop
        this.sizePopup.style.display = 'none';
      }
    }
    
    // Application de la taille recommandée à la sélection du produit
    applyRecommendedSize() {
      // Sauvegarde des données avant d'appliquer la taille
      console.log("Sauvegarde des données lors de l'application de la taille recommandée");
      this.saveUserData();
      
      // Recherche des sélecteurs de taille
      const topSizeSelectors = document.querySelectorAll('input[name="Size"], input[name="option-0"], select[name="option-0"]');
      const bottomSizeSelectors = document.querySelectorAll('input[name="option-1"], select[name="option-1"]');
      
      // Récupération des tailles recommandées
      let topSize, bottomSize;
      
      if (this.productType === 'body') {
        const bodySizeElement = document.getElementById('naked-size-body-size');
        if (bodySizeElement) {
          topSize = bodySizeElement.textContent;
          bottomSize = topSize; // Même taille pour le body
        } else {
          // Fallback sur l'ancien système
          const topSizeElement = document.getElementById('naked-size-top-size');
          topSize = topSizeElement ? topSizeElement.textContent : null;
        }
      } else {
        const topSizeElement = document.getElementById('naked-size-top-size');
        const bottomSizeElement = document.getElementById('naked-size-bottom-size');
        
        topSize = topSizeElement ? topSizeElement.textContent : null;
        bottomSize = bottomSizeElement ? bottomSizeElement.textContent : null;
      }
      
      if (!topSize) {
        console.error('Top size element not found');
        return;
      }
      
      // Application au sélecteur de taille de haut
      if (topSizeSelectors.length > 0) {
        const topSelector = topSizeSelectors[0];
        
        if (topSelector.tagName === 'SELECT') {
          // Pour les listes déroulantes
          for (let i = 0; i < topSelector.options.length; i++) {
            if (topSelector.options[i].value === topSize) {
              topSelector.selectedIndex = i;
              const event = new Event('change', { bubbles: true });
              topSelector.dispatchEvent(event);
              break;
            }
          }
        } else {
          // Pour les boutons radio
          for (let i = 0; i < topSizeSelectors.length; i++) {
            if (topSizeSelectors[i].value === topSize) {
              topSizeSelectors[i].checked = true;
              const event = new Event('change', { bubbles: true });
              topSizeSelectors[i].dispatchEvent(event);
              break;
            }
          }
        }
      }
      
      // Application au sélecteur de taille de bas (uniquement pour les ensembles)
      if (this.productType === 'ensemble' && bottomSizeSelectors.length > 0 && bottomSize) {
        const bottomSelector = bottomSizeSelectors[0];
        
        if (bottomSelector.tagName === 'SELECT') {
          // Pour les listes déroulantes
          for (let i = 0; i < bottomSelector.options.length; i++) {
            if (bottomSelector.options[i].value === bottomSize) {
              bottomSelector.selectedIndex = i;
              const event = new Event('change', { bubbles: true });
              bottomSelector.dispatchEvent(event);
              break;
            }
          }
        } else {
          // Pour les boutons radio
          for (let i = 0; i < bottomSizeSelectors.length; i++) {
            if (bottomSizeSelectors[i].value === bottomSize) {
              bottomSizeSelectors[i].checked = true;
              const event = new Event('change', { bubbles: true });
              bottomSizeSelectors[i].dispatchEvent(event);
              break;
            }
          }
        }
      }
      
      // Utiliser la nouvelle méthode de fermeture
      this.closePopup();
    }
    
    // Fonction pour enregistrer les données de l'utilisateur
    saveUserData() {
      // Déterminer les tailles recommandées selon le type de produit
      let topSize, bottomSize, bodySize;
      
      if (this.productType === 'body') {
        // Essayer d'abord de récupérer depuis le nouveau layout
        const bodySizeElem = document.getElementById('naked-size-body-size');
        if (bodySizeElem) {
          bodySize = bodySizeElem.textContent;
          topSize = bodySize;
          bottomSize = bodySize;
        } else {
          // Fallback sur l'ancien layout
          const topSizeElem = document.getElementById('naked-size-top-size');
          const bottomSizeElem = document.getElementById('naked-size-bottom-size');
          
          if (topSizeElem && bottomSizeElem) {
            topSize = topSizeElem.textContent;
            bottomSize = bottomSizeElem.textContent;
            
            // Déterminer la taille la plus grande pour le body
            const sizeRank = { 'S': 1, 'M': 2, 'L': 3, 'XL': 4 };
            bodySize = sizeRank[topSize] >= sizeRank[bottomSize] ? topSize : bottomSize;
          }
        }
      } else {
        // Ensemble: récupérer les tailles distinctes
        const topSizeElem = document.getElementById('naked-size-top-size');
        const bottomSizeElem = document.getElementById('naked-size-bottom-size');
        
        if (topSizeElem && bottomSizeElem) {
          topSize = topSizeElem.textContent;
          bottomSize = bottomSizeElem.textContent;
        }
      }
      
      if (topSize) {
        console.log("Sauvegarde des données utilisateur...");
        
        const userData = {
          height: this.userData.height,
          weight: this.userData.weight,
          age: this.userData.age,
          stomach: this.userData.stomach,
          hips: this.userData.hips,
          seat: this.userData.seat,
          braSize: this.userData.braSize,
          bottomSize: this.userData.bottomSize,
          topSize: topSize,
          bottomSizeValue: bottomSize,
          productType: this.productType,
          lastUpdated: new Date().toISOString()
        };
        
        // Si c'est un body, ajouter la taille bodySize
        if (this.productType === 'body' && bodySize) {
          userData.bodySize = bodySize;
        }
        
        console.log("Données à sauvegarder:", userData);
        
        // Sauvegarder dans le localStorage
        localStorage.setItem(STORAGE_KEY, JSON.stringify(userData));
        
        // Mettre à jour l'affichage du bouton après fermeture de la popup
        setTimeout(updateButtonText, 500);
      }
    }
  }
  
  // Observer les changements dans le DOM pour détecter quand l'étape 7 devient active
  document.addEventListener('DOMContentLoaded', function() {
    // Vérifier si l'HTML est dans le format mis à jour
    if (!document.querySelector('.naked-size-result-body') && !document.querySelector('.naked-size-result-ensemble')) {
      // Si le nouveau format n'est pas présent, mettre à jour le HTML pour compatibilité
      updateResultsHTML();
    }
    
    // Observer les changements dans le DOM pour détecter quand l'étape 7 devient active
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const resultStep = document.querySelector('.naked-size-step[data-step="7"]');
          if (resultStep && resultStep.classList.contains('active')) {
            // L'étape 7 est active, appliquer les adaptations pour le body
            setTimeout(function() {
              adaptBodyDisplay();
            }, 50);
            
            // Mettre à jour le bouton Appliquer
            updateApplyButton();
          }
        }
      });
    });
    
    // Observer l'élément contenant les étapes
    const stepContainer = document.querySelector('.naked-size-form-side');
    if (stepContainer) {
      observer.observe(stepContainer, { attributes: true, subtree: true });
      console.log("Observateur des résultats configuré");
    }
    
    // Mise à jour du HTML des résultats pour prendre en charge le nouveau format
    function updateResultsHTML() {
      const resultStep = document.querySelector('.naked-size-step[data-step="7"]');
      if (!resultStep) return;
      
      // Sauvegarder le contenu original
      const originalContent = resultStep.innerHTML;
      
      // Créer le nouveau HTML
      const newHTML = `
        <h3 class="naked-size-step-title">${window.nakedSizeT('step7_title', 'VOTRE TAILLE IDÉALE')}</h3>
        
        <!-- Résultats pour Body -->
        <div class="naked-size-result-body" style="display: none;">
          <div class="naked-size-recommendation">
            <div class="naked-size-recommendation-top">
              <h4>${window.nakedSizeT('size_label', 'TAILLE :')} <span id="naked-size-body-size"></span></h4>
            </div>
          </div>
          
          <div class="naked-size-social-proof">
            <div class="naked-size-social-proof-icon">
              <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="naked-size-check-icon">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <div class="naked-size-social-proof-content">
              <div class="naked-size-trust-badge">
                <svg class="naked-size-seal" viewBox="0 0 40 40">
                  <circle cx="20" cy="20" r="19" fill="none" stroke="currentColor" stroke-width="1"></circle>
                  <text x="20" y="20" font-size="9" text-anchor="middle" alignment-baseline="middle" font-weight="bold" fill="currentColor">NAKED</text>
                  <text x="20" y="27" font-size="5" text-anchor="middle" font-weight="normal" fill="currentColor">VERIFIED FIT</text>
                </svg>
              </div>
              <p id="naked-size-body-social-proof">${window.nakedSizeT('social_proof_body', 'Nos clientes ayant votre morphologie choisissent cette taille')}</p>
            </div>
          </div>
        </div>
        
        <!-- Résultats pour Ensemble -->
        <div class="naked-size-result-ensemble" style="display: none;">
          <div class="naked-size-recommendation">
            <div class="naked-size-recommendation-top">
              <h4>${window.nakedSizeT('top_size', 'HAUT :')} <span id="naked-size-top-size"></span></h4>
            </div>
            <div class="naked-size-recommendation-bottom">
              <h4>${window.nakedSizeT('bottom_size', 'BAS :')} <span id="naked-size-bottom-size"></span></h4>
            </div>
          </div>
          
          <div class="naked-size-social-proof">
            <div class="naked-size-social-proof-icon">
              <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="naked-size-check-icon">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <div class="naked-size-social-proof-content">
              <div class="naked-size-trust-badge">
                <svg class="naked-size-seal" viewBox="0 0 40 40">
                  <circle cx="20" cy="20" r="19" fill="none" stroke="currentColor" stroke-width="1"></circle>
                  <text x="20" y="20" font-size="9" text-anchor="middle" alignment-baseline="middle" font-weight="bold" fill="currentColor">NAKED</text>
                  <text x="20" y="27" font-size="5" text-anchor="middle" font-weight="normal" fill="currentColor">VERIFIED FIT</text>
                </svg>
              </div>
              <p id="naked-size-ensemble-social-proof">${window.nakedSizeT('social_proof_ensemble', 'Nos clientes ayant votre morphologie choisissent ces tailles pour leur ensemble')}</p>
            </div>
          </div>
        </div>
        
        <div class="naked-size-navigation">
          <button type="button" class="naked-size-edit-btn" id="step7-edit">${window.nakedSizeT('edit_answers', 'Modifier mes réponses')}</button>
          <button type="button" class="naked-size-apply-btn" id="step7-apply">${window.nakedSizeT('apply_size', 'Appliquer cette taille')}</button>
        </div>
      `;
      
      // Remplacer le contenu de l'étape
      resultStep.innerHTML = newHTML;
      
      console.log('HTML des résultats mis à jour pour le nouveau format');
    }
    
    // Fonction d'adaptation pour les body
    function adaptBodyDisplay() {
      // Vérifier si c'est un body en examinant le titre du produit
      const productTitle = document.querySelector('.naked-size-popup-title h2')?.textContent || '';
      const isBody = productTitle.toLowerCase().includes('body');
      
      // Déterminer si nous utilisons le nouveau ou l'ancien layout
      const useNewLayout = document.querySelector('.naked-size-result-body') && document.querySelector('.naked-size-result-ensemble');
      
      if (useNewLayout) {
        // Nouveau layout: afficher le bon conteneur
        const bodyContainer = document.querySelector('.naked-size-result-body');
        const ensembleContainer = document.querySelector('.naked-size-result-ensemble');
        
        if (bodyContainer && ensembleContainer) {
          bodyContainer.style.display = isBody ? 'block' : 'none';
          ensembleContainer.style.display = isBody ? 'none' : 'block';
          
          if (isBody) {
            // Pour body, transférer la taille du haut vers la taille body
            const topSizeElem = document.getElementById('naked-size-top-size');
            const bodySizeElem = document.getElementById('naked-size-body-size');
            
            if (topSizeElem && bodySizeElem && topSizeElem.textContent) {
              bodySizeElem.textContent = topSizeElem.textContent;
            }
          }
        }
      } else {
        // Ancien layout: adapter l'affichage existant
        if (isBody) {
          // Récupérer les éléments
          const resultStep = document.querySelector('.naked-size-step[data-step="7"]');
          const topSizeElem = document.getElementById('naked-size-top-size');
          const bottomSizeElem = document.getElementById('naked-size-bottom-size');
          const bottomSection = document.querySelector('.naked-size-recommendation-bottom');
          const topSection = document.querySelector('.naked-size-recommendation-top');
          
          if (!resultStep || !topSizeElem || !bottomSizeElem) return;
          
          // Marquer l'étape pour le CSS
          resultStep.setAttribute('data-product-type', 'body');
          
          // Déterminer la taille la plus grande
          const sizeRank = { 'S': 1, 'M': 2, 'L': 3, 'XL': 4 };
          const topSize = topSizeElem.textContent;
          const bottomSize = bottomSizeElem.textContent;
          const bestSize = sizeRank[topSize] >= sizeRank[bottomSize] ? topSize : bottomSize;
          
          // Stocker également la taille du body pour le bouton
          const sizeData = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
          sizeData.bodySize = bestSize;
          localStorage.setItem(STORAGE_KEY, JSON.stringify(sizeData));
          
          // Mettre à jour l'affichage du titre principal
          const title = resultStep.querySelector('.naked-size-step-title');
          if (title) title.textContent = window.nakedSizeT('step7_title_body', 'VOTRE TAILLE DE BODY IDÉALE');
          
          // Modifier le texte "HAUT :" pour supprimer le mot "HAUT"
          if (topSection) {
            const topLabel = topSection.querySelector('h4');
            if (topLabel) {
              topLabel.innerHTML = '<span>' + bestSize + '</span>';
            }
          }
          
          // Masquer la section du bas
          if (bottomSection) bottomSection.style.display = 'none';
          
          // Ajouter une explication
          if (topSection) {
            // Vérifier si l'explication n'a pas déjà été ajoutée
            if (!document.querySelector('.naked-size-body-explanation')) {
              const explanation = document.createElement('p');
              explanation.className = 'naked-size-body-explanation';
              explanation.textContent = window.nakedSizeT('body_explanation', 'Pour un body, nous recommandons une taille qui s\'adaptera parfaitement à votre morphologie.');
              topSection.appendChild(explanation);
            }
          }
        }
      }
    }
    
    // Modifier le bouton Appliquer pour qu'il dise "Continuer"
    function updateApplyButton() {
      const applyBtn = document.querySelector('.naked-size-step[data-step="7"] .naked-size-apply-btn');
      if (applyBtn) {
        applyBtn.textContent = window.nakedSizeT('continue', 'Continuer');
        console.log("Bouton Appliquer mis à jour -> 'Continuer'");
      }
    }
  });
  
  // Fonction pour détecter le type de produit actuel
  function detectCurrentProductType() {
    // Récupérer le titre du produit de différentes façons possibles selon la structure du site
    const productTitle = document.querySelector('.product__title h1')?.textContent || 
                       document.querySelector('.product-single__title')?.textContent || 
                       document.querySelector('h1.product-title')?.textContent ||
                       document.querySelector('h1')?.textContent || 
                       document.querySelector('.product-title')?.textContent ||
                       '';
    
    console.log("Titre du produit détecté:", productTitle);
    
    // Vérifier d'abord si c'est un body (priorité la plus élevée)
    if (productTitle.toLowerCase().includes('body')) {
      console.log("Produit détecté comme un BODY");
      return 'body';
    }
    
    // Vérifier s'il s'agit d'un ensemble
    const ensemblePatterns = ['deux pièces', 'trois pièces', 'quatre pièces', 'cinq pièces', 'ensemble'];
    for (const pattern of ensemblePatterns) {
      if (productTitle.toLowerCase().includes(pattern)) {
        console.log("Produit détecté comme un ENSEMBLE");
        return 'ensemble';
      }
    }
    
    // Par défaut pour les ambiguïtés, vérifier si la structure ressemble à un body
    if (productTitle.toLowerCase().includes('ultra') || 
        productTitle.toLowerCase().includes('polyvalent') ||
        productTitle.toLowerCase().includes('pour femme')) {
      console.log("Produit présumé comme un BODY (par inférence)");
      return 'body';
    }
    
    // Par défaut, considérer comme un ensemble
    console.log("Produit considéré par défaut comme un ENSEMBLE");
    return 'ensemble';
  }
  
  // Fonction pour mettre à jour le texte du bouton en fonction des résultats précédents
  function updateButtonText() {
    try {
      // Récupérer les données stockées
      const storedData = localStorage.getItem(STORAGE_KEY);
      if (!storedData) {
        console.log("Aucune donnée stockée trouvée");
        return;
      }
      
      const userData = JSON.parse(storedData);
      if (!userData.topSize) {
        console.log("Données de taille incomplètes");
        return;
      }
      
      // Récupérer le bouton
      const sizeButton = document.getElementById('naked-size-button');
      if (!sizeButton) {
        console.log("Bouton de taille non trouvé");
        return;
      }
      
      // Déterminer le type de produit actuel
      const currentProductType = detectCurrentProductType();
      console.log("Type de produit actuel:", currentProductType);
      
      // Ajouter la classe pour le style spécifique
      sizeButton.classList.add('with-size');
      
      if (currentProductType === 'body') {
        // Pour un body, utiliser la plus grande des deux tailles
        const sizeRank = { 'S': 1, 'M': 2, 'L': 3, 'XL': 4 };
        const topSize = userData.topSize || 'S';
        const bottomSize = userData.bottomSizeValue || 'S';
        const bestSize = userData.bodySize || (sizeRank[topSize] >= sizeRank[bottomSize] ? topSize : bottomSize);
        
        console.log(`Affichage pour BODY: topSize=${topSize}, bottomSize=${bottomSize}, bestSize=${bestSize}`);
        sizeButton.innerHTML = `${window.nakedSizeT('size_button_with_body_size', 'Votre taille parfaite pour ce body est')} <span class="size-result">${bestSize}</span>`;
      } else {
        // Pour un ensemble, afficher les deux tailles
        console.log(`Affichage pour ENSEMBLE: topSize=${userData.topSize}, bottomSize=${userData.bottomSizeValue}`);
        sizeButton.innerHTML = `${window.nakedSizeT('size_button_with_size', 'Votre taille parfaite pour cet ensemble est')} <span class="size-result">${userData.topSize}/${userData.bottomSizeValue}</span>`;
      }
    } catch (error) {
      console.error('Erreur lors de la mise à jour du texte du bouton:', error);
      // En cas d'erreur, revenir au texte par défaut
      const sizeButton = document.getElementById('naked-size-button');
      if (sizeButton) {
        sizeButton.textContent = window.nakedSizeT('calculate_size', 'Calculer ma taille');
      }
    }
  }
  
  // Initialiser les modifications une fois le widget chargé
  function initEnhancements() {
    console.log("Initialisation des améliorations du widget...");
    
    // Modifier le texte initial du bouton si aucune donnée n'existe
    const sizeButton = document.getElementById('naked-size-button');
    if (sizeButton) {
      // Essayer de récupérer des données stockées
      const storedData = localStorage.getItem(STORAGE_KEY);
      
      if (!storedData && sizeButton.textContent.trim() === 'Je choisis ma taille') {
        sizeButton.textContent = window.nakedSizeT('calculate_size', 'Calculer ma taille');
        console.log("Texte du bouton mis à jour -> 'Calculer ma taille'");
      } else if (storedData) {
        // Si des données existent, mettre à jour avec le bon texte selon le type de produit
        console.log("Données stockées trouvées, mise à jour du bouton avec la taille appropriée");
        updateButtonText();
      }
    }
    
    // Observer les changements pour l'étape des résultats
    setupResultObserver();
    
    // Améliorer les méthodes du widget
    enhanceClosePopup();
    enhanceApplyRecommendedSize();
    
    // Si la popup est déjà ouverte à l'étape 7, mettre à jour le bouton Appliquer
    updateApplyButton();
    
    // Ajouter ces nouvelles fonctionnalités
    setupRecommendationUpdateListener();
    resetWidgetOnOpen();
  }
  
  // Observateur pour détecter quand l'étape 7 devient active
  function setupResultObserver() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const resultStep = document.querySelector('.naked-size-step[data-step="7"]');
          if (resultStep && resultStep.classList.contains('active')) {
            // Mettre à jour le bouton d'application
            updateApplyButton();
          }
        }
      });
    });
    
    // Observer l'élément contenant les étapes
    const stepContainer = document.querySelector('.naked-size-form-side');
    if (stepContainer) {
      observer.observe(stepContainer, { attributes: true, subtree: true });
      console.log("Observateur des résultats configuré");
    }
  }
  
  // Modifier le bouton Appliquer dans les résultats
  function updateApplyButton() {
    const applyBtn = document.querySelector('.naked-size-step[data-step="7"] .naked-size-apply-btn');
    if (applyBtn) {
      applyBtn.textContent = window.nakedSizeT('continue', 'Continuer');
      console.log("Bouton Appliquer mis à jour -> 'Continuer'");
    }
  }
  
  // Modifier la méthode closePopup pour sauvegarder les données lors de la fermeture
  function enhanceClosePopup() {
    if (window.nakedSizeRecommender) {
      const originalClosePopup = window.nakedSizeRecommender.closePopup;
      
      // Remplacer par une version améliorée qui sauvegarde les données
      window.nakedSizeRecommender.closePopup = function() {
        // Vérifier si l'étape 7 (résultats) est active avant de sauvegarder
        const resultStep = document.querySelector('.naked-size-step[data-step="7"]');
        if (resultStep && resultStep.classList.contains('active')) {
          console.log("Sauvegarde des données lors de la fermeture de la popup");
          this.saveUserData();
        }
        
        // Appeler la méthode originale
        originalClosePopup.apply(this, arguments);
      };
      
      console.log("Méthode closePopup améliorée");
    }
  }
  
  // Également modifier applyRecommendedSize pour sauvegarder les données
  function enhanceApplyRecommendedSize() {
    if (window.nakedSizeRecommender) {
      const originalApplyRecommendedSize = window.nakedSizeRecommender.applyRecommendedSize;
      
     window.nakedSizeRecommender.applyRecommendedSize = function() {
  // Sauvegarder les données avant d'appliquer la taille
  console.log("Sauvegarde des données lors de l'application de la taille recommandée");
  this.saveUserData();
  
  // Appeler la méthode originale
  originalApplyRecommendedSize.apply(this, arguments);
};

console.log("Méthode applyRecommendedSize améliorée");
}
}

// NOUVELLE FONCTION: Observer les mises à jour de recommandation
function setupRecommendationUpdateListener() {
  // Observer les changements dans l'étape des résultats pour capturer les nouvelles recommandations
  const resultObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'characterData' || mutation.type === 'childList') {
        // Vérifier si nous sommes dans l'étape des résultats
        const resultStep = document.querySelector('.naked-size-step[data-step="7"]');
        if (resultStep && resultStep.classList.contains('active')) {
          // Vérifier si nous utilisons le nouveau ou l'ancien layout
          const useNewLayout = document.querySelector('.naked-size-result-body') && 
                             document.querySelector('.naked-size-result-ensemble');
          
          let newTopSize, newBottomSize, newBodySize;
          const isBody = resultStep.getAttribute('data-product-type') === 'body';
          
          if (useNewLayout) {
            // Nouveau layout: récupérer depuis les structures spécifiques
            if (isBody) {
              newBodySize = document.getElementById('naked-size-body-size')?.textContent;
              newTopSize = newBodySize;
              newBottomSize = newBodySize;
            } else {
              newTopSize = document.getElementById('naked-size-top-size')?.textContent;
              newBottomSize = document.getElementById('naked-size-bottom-size')?.textContent;
            }
          } else {
            // Ancien layout: récupérer depuis la structure traditionnelle
            newTopSize = document.getElementById('naked-size-top-size')?.textContent;
            newBottomSize = document.getElementById('naked-size-bottom-size')?.textContent;
            
            if (isBody) {
              // Pour body, prendre la taille la plus grande
              const sizeRank = { 'S': 1, 'M': 2, 'L': 3, 'XL': 4 };
              newBodySize = sizeRank[newTopSize] >= sizeRank[newBottomSize] ? newTopSize : newBottomSize;
            }
          }
          
          if (newTopSize) {
            console.log(`Nouvelle recommandation détectée: top=${newTopSize}, bottom=${newBottomSize}${newBodySize ? ', body=' + newBodySize : ''}`);
            
            // Mettre à jour immédiatement les données stockées
            try {
              const storedData = localStorage.getItem(STORAGE_KEY);
              if (storedData) {
                const userData = JSON.parse(storedData);
                userData.topSize = newTopSize;
                userData.bottomSizeValue = newBottomSize;
                if (newBodySize) userData.bodySize = newBodySize;
                userData.lastUpdated = new Date().toISOString();
                localStorage.setItem(STORAGE_KEY, JSON.stringify(userData));
                console.log("Données stockées mises à jour avec les nouvelles tailles");
              }
            } catch (error) {
              console.error("Erreur lors de la mise à jour des données:", error);
            }
          }
        }
      }
    });
  });
  
  // Observer tous les changements dans le contenu de l'étape des résultats
  const resultElements = document.querySelectorAll('.naked-size-step[data-step="7"] .naked-size-recommendation, .naked-size-result-body, .naked-size-result-ensemble');
  resultElements.forEach(element => {
    if (element) {
      resultObserver.observe(element, { 
        characterData: true, 
        childList: true, 
        subtree: true 
      });
    }
  });
  console.log("Observateur configuré pour les mises à jour de recommandation");
}

// NOUVELLE FONCTION: Réinitialiser le widget à chaque ouverture
function resetWidgetOnOpen() {
  const sizeButton = document.getElementById('naked-size-button');
  if (sizeButton) {
    sizeButton.addEventListener('click', function() {
      console.log("Widget ouvert, préparation à capturer de nouvelles recommandations");
      // Attendre que la popup soit ouverte
      setTimeout(function() {
        setupRecommendationUpdateListener();
      }, 500);
    });
  }
}

// Fonction d'optimisation des performances
function optimizePerformance() {
  // Débouncer les événements de redimensionnement
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      const wasMobile = window.nakedSizeRecommender.isMobile;
      window.nakedSizeRecommender.isMobile = window.innerWidth <= 768;
      
      if (wasMobile !== window.nakedSizeRecommender.isMobile) {
        window.nakedSizeRecommender.initializeMobileSliders();
      }
    }, 250);
  });
  
  // Appliquer le lazy loading pour l'image du produit
  const productImage = document.getElementById('naked-size-product-image');
  if (productImage) {
    productImage.loading = 'lazy';
  }
}

// Initialisation du widget quand le DOM est chargé
document.addEventListener('DOMContentLoaded', function() {
  console.log("DOM chargé, initialisation du widget...");
  
  // S'assurer que tous les éléments nécessaires sont présents
  if (document.getElementById('naked-size-button') && document.getElementById('naked-size-popup')) {
    // Créer l'instance du widget
    window.nakedSizeRecommender = new NAKEDSizeRecommender();
    
    // Initialiser les améliorations après la création du widget
    setTimeout(initEnhancements, 500);
    
    // Ajouter l'optimisation des performances
    optimizePerformance();
  } else {
    console.warn('NAKED Size Recommender: Éléments manquants dans le DOM');
  }
});

// Vérifier les changements de page pour les applications SPA
let lastUrl = location.href;
new MutationObserver(() => {
  const url = location.href;
  if (url !== lastUrl) {
    lastUrl = url;
    console.log("Changement de page détecté, mise à jour du bouton...");
    setTimeout(updateButtonText, 500); // Mettre à jour le texte du bouton après changement de page
  }
}).observe(document, {subtree: true, childList: true});

// Exécution immédiate pour les pages déjà chargées
console.log("Configuration initiale terminée, tentative de mise à jour immédiate...");
setTimeout(updateButtonText, 100);

})();